import React, { Component } from "react"
import { instanceOf } from "prop-types"
import { Route, Redirect, Switch, withRouter } from "react-router-dom"
import { withCookies, Cookies } from "react-cookie"
import * as cookieNames from "../constants/Cookies"
import * as countryHelper from "../helpers/countryHelper"
import * as cookieHelper from "../../helpers/cookie"
import * as storageHelper from "../../helpers/storageHelper"
import axios from "axios"

import QueryString from "query-string"
import * as path from "../constants/Paths"
import * as endpoint from "../constants/Endpoints"
import * as tracking from "../helpers/tracking"

import ParkingList from "./ParkingList/parkingList"
import ParkingAmendmentList from "./ParkingList/parkingAmendmentList"
import ParkingAcceptConditionsModal from "./ParkingList/parkingAcceptConditionsModal"
import ParkingDetailsModal from "./ParkingList/parkingDetailsModal"
import ParkingShowMapModal from "./ParkingList/parkingShowMapModal"

import ProgressIndicator from "./progressIndicator"
import StepHeader from "./stepHeader"
import NotFound from "./notFound"
import AmendSearch from "./Amendment/amendSearch"
import AmendManage from "./Amendment/amendManage"
import AmendProgressIndicator from "./Amendment/amendProgressIndicator"
import ParkingExtraServicesSelectorModal from "./ExtraServices/parkingExtraServicesSelectorModal"
import ParkingExtraServicesInfoModal from "./ExtraServices/parkingExtraServicesInfoModal"
import Checkout from "./Checkout/checkout"
import ParkingTimeModal from "./miniBasket/parkingTimeModal"
import AmendForgotReferenceModal from "./Amendment/amendForgotReferenceModal"
import AmendInformation from "./Amendment/amendInformation"
import config from "react-global-configuration"
import AmendHeaderSection from "./Amendment/amendHeaderSection"
import Map from "./Map/map"
import Spinner from "./spinner"
import Receipt from "./Receipt/Receipt"
import ReceiptHowto from "./Receipt/ReceiptHowto"
import BookingStarter from "./bookingStarter"
import BookingEdit from "./BookingEdit"
import FaqTop3 from "./common/FaqTop3"
import GenericModal from "./common/genericModal"
import MenuBar from "./common/menuBar"
import SpinnerModal from "./common/spinnerModal"
import ParkingExtraServiceAcceptConditionsModal from "./ExtraServices/parkingExtraServiceAcceptConditionsModal"
import ParkingCheckoutBasket from "./miniBasket/parkingCheckoutBasket"
import SectionHeader from "./sectionHeader"
import ParkingExtraServicesPodiumList from "./ExtraServices/parkingExtraServicesPodiumList"
import ParkingExtraServicesDetailsModal from "./ExtraServices/parkingExtraServicesDetailsModal"
import Wallet from "@bambora/wallet"
import BookingHero from "./bookingHero"
import ParkingProductHightlight from "./ParkingList/parkingProductHighlight"
import ParkingProductBrowser from "./ParkingList/parkingProductBrowser"
import ParkingBuyMemberProductModal from "./ParkingList/parkingBuyMemberProductModal"
import ReceiptTextualGuide from "./Receipt/receiptTextualGuide"
import SubnavigationFat from "./common/SubnavigationFat"
import smoothscroll from "smoothscroll-polyfill"
import { RedirectCheckout } from "@bambora/checkout-sdk-web"
import RefundGuarantee from "./ParkingList/refundGuarantee"
import SimpleErrorModal from "../../shared/modal/simple-error-modal"
import { DateTime } from "luxon"
import Header from "../../shared/header/header-component"
import BookingExtend from "./BookingExtend"
import Sticky from "../../styleguide/js/components/sticky"
import ParkingFollowFlight from "../../shared/parking-follow-flight/parking-follow-flight-component"
import { UserProfile } from "../../hooks/userProfile"
import { getQueryStringValue } from "../../api/queryStringHelper"

export const emailValidatingRegex =
  /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
export const hostnameValidatingRegex =
  /^([a-zA-Z0-9]|[a-zA-Z0-9][a-zA-Z0-9-]{0,61}[a-zA-Z0-9])(\.([a-zA-Z0-9]|[a-zA-Z0-9][a-zA-Z0-9-]{0,61}[a-zA-Z0-9]))*$/
export const specialCharsRegex = /[äöüÄÖÜæøåÆØÅ]/
export const phoneRegex = /^(\+[\d]*)$/
export const appleRelayRegex = /(privaterelay.appleid.com)$/
export const cphEmailRegex = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))+@cph\.dk$/

// https://booking.cph.dk/da/search/?ad=10%2F04%2F2019&at=00%3A30&dd=15%2F04%2F2019&dt=07%3A00&ac=CPH

class BookingJourney extends Component {
  // http://localhost:55823/api/v1/da/booking/search?fromDate=2018-09-03%2006%3A00&toDate=2018-09-05%2022%3A00

  static propTypes = {
    cookies: instanceOf(Cookies).isRequired,
  }

  constructor(props) {
    super(props)
    const queryParam = QueryString.parse(this.props.location.search)
    const arrivalLeadTimeHours = props.content.leadTimeInHours || 1
    const arrivalGranularityMilliseconds = 30 * 60 * 1000

    const earliestArrivalTimeStamp = new Date(new Date().getTime() + arrivalLeadTimeHours * 60 * 60 * 1000)
    const arrivalDate = new Date(Math.ceil(earliestArrivalTimeStamp / arrivalGranularityMilliseconds) * arrivalGranularityMilliseconds)
    const departureDate = new Date()
    departureDate.setDate(departureDate.getDate() + 8)
    const durationDays = Math.ceil(Math.abs(new Date(departureDate).getTime() - new Date(arrivalDate).getTime()) / (1000 * 60 * 60 * 24))

    const ad = `${arrivalDate.getFullYear()}-${(arrivalDate.getMonth() + 1).toLocaleString("en-US", { minimumIntegerDigits: 2 })}-${arrivalDate
      .getDate()
      .toLocaleString("en-US", { minimumIntegerDigits: 2 })}`

    let at = `${arrivalDate.getHours().toLocaleString("en-US", { minimumIntegerDigits: 2 })}:${arrivalDate
      .getMinutes()
      .toLocaleString("en-US", { minimumIntegerDigits: 2 })}`
    if (at === "00:00") at = "00:30" // midnight is not a selectable value

    const dd = `${departureDate.getFullYear()}-${(departureDate.getMonth() + 1).toLocaleString("en-US", { minimumIntegerDigits: 2 })}-${departureDate
      .getDate()
      .toLocaleString("en-US", { minimumIntegerDigits: 2 })}`

    const consentContent = this.getConsentContent()
    const marketingConsentContent = this.getMarketingConsentContent()
    const termsAndConditionsContent = this.getTermsAndConditionsContent()
    const consentInformation = {}

    const hideFields = config.get("textKeys.checkout.hideBillingFields") || {}

    marketingConsentContent.items && marketingConsentContent.items.forEach((item) => (consentInformation[item.consentId] = item.isPreselected))

    smoothscroll.polyfill()

    this.state = {
      error: null,
      isLoaded: false,
      arrivalDate: queryParam.ad || ad,
      arrivalTime: queryParam.at || at,
      departureDate: queryParam.dd || dd,
      departureTime: queryParam.dt || "17:30",
      hasQueryParameters: !!(queryParam.ad || queryParam.at || queryParam.dd || queryParam.dt),
      parkingProductId: queryParam.parkingProductId || undefined,
      durationDays: durationDays,
      airportCode: queryParam.ac || "CPH",
      voucher: queryParam.voucher || "",
      affiliateCode: queryParam.affiliate || "",
      currentStep: 0,
      manageBookingResult: undefined,
      changeFromBookingGuid: queryParam.cfguid || undefined,
      isUpsold: queryParam.isUpsold || undefined,
      changeFromBooking: undefined,
      bookingExtras: undefined,
      bookingExtrasConfiguration: undefined,
      extraServicesInfoModalActive: false,
      extraServiceModalSelectorActive: false,
      extraServiceModalProduct: undefined,
      isParkingHighlightModalActive: false,
      productCategories: [],
      allProducts: [],
      bookingResult: undefined,
      parkingTimeModalActive: false,
      forgotReferenceModalActive: false,
      ajaxSpinnerActive: false,
      userAccountDetails: undefined,
      loadingContactDetails: false,
      billingAddress: {
        firstName: "",
        lastName: "",
        postcode: "",
        town: "",
        email: "",
        mobilePhone: "",
        countryId: hideFields?.hideCountry ? "" : "293" || "293",
        country: hideFields?.hideCountry ? "" : countryHelper.getCountryName("293") || countryHelper.getCountryName("293"),
      },
      walletPaymentOptions: {},
      selectedPaymentOption: [1],
      vechicleInformation: {
        vehicleColour: "",
        vehicleMake: "",
        vehicleModel: "",
        vehicleRegistrationNumber: "",
      },
      flightInformation: {
        outboundDate: undefined,
        inboundDate: undefined,
        outboundFlightNumber: undefined,
        inboundFlightNumber: undefined,
      },
      consentInformation,
      consentContent,
      termsAndConditionsContent,
      marketingConsentContent,
      wantRefund: undefined,
      paymentData: {},
      paymentModalActive: false,
      selectedPaymentType: {},
      checkoutErrors: {
        firstName: true,
        lastName: true,
        postcode: true,
        town: true,
        email: true,
        mobilePhone: true,
        terms_and_condition: true,
        showErrors: false,
      },
      ammendmentEmail: queryParam.email || "",
      ammendmentReference: queryParam.reference || "",
      receiptShouldTrack: false,
      parkingHighlights: undefined,
      refundGuaranteeModalOpen: false,
      refundGuaranteeModalData: { h3: "", richText: "" },
      queryStringDiffersFromAmendedBooking: false,
      showMapInitially: true,
      hasScrolled: false,
      flightId: queryParam.flightId || undefined,
      hasLoadedUpgrade: false,
      setLoginStateAttempted: false,
    }
  }

  getMarketingConsentContent = () => {
    const allConsent = this.getConsentContent()

    return {
      header: allConsent.header,
      items: allConsent.items && allConsent.items.filter((i) => i.consentId !== "terms_and_condition"),
    }
  }

  getTermsAndConditionsContent = () => {
    const allConsent = this.getConsentContent()
    const items = allConsent.items && allConsent.items.filter((i) => i.consentId === "terms_and_condition")
    return (items && items[0]) || {}
  }

  getConsentContent = () => {
    const data =
      this.props.consentContent ||
      JSON.parse(`
        {
            "header": "Det med småt...",
            "items": [
                {
                    "consentId":"terms_and_condition",
                    "isRequired": true,
                    "isPreselected": false,
                    "header": "Handelsbetingelser",
                    "body": "Jeg godkender <a href='https://info.parkering.cph.dk/vilk%C3%A5r-cph-parkering' target='_blank'>handelsbetingelserne</a>"
                },
                {
                    "consentId":"Parking Consent",
                    "isRequired": false,
                    "isPreselected": true,
                    "header": "Mails om parkeringsprodukter",
                    "body": "Jeg er indforstået med, at Københavns Lufthavne A/S kan anvende min afgivne e-mailadresse til at sende reklame via elektronisk post for tilsvarende produkter og tjenesteydelser, som mit nuværende køb. Du kan til enhver tid tilbagekalde dit samtykke ved at anvende link i modtagne e-mails."
                },
                {
                    "consentId":"Marketing Consent",
                    "isRequired": false,
                    "isPreselected": false,
                    "header": "Mails om lufthavnen",
                    "body": "Jeg giver samtykke til at modtage markedsføring via elektronisk post, f.eks. e-mail, SMS, MMS, sociale medier, elektroniske platforme og apps fra Københavns Lufthavne A/S (”CPH”). Markedsføringen omfatter information om Københavns Lufthavn samt konkurrencer, events, fordelsprogrammer og parkeringsydelser udbudt af CPH. Markedsføringen omfatter også CPHs samarbejdspartnere, der driver spisesteder, butikker, hoteller og flyselskaber samt andre samarbejdspartnere, beliggende i eller ved Københavns Lufthavn eller som opererer fra Københavns Lufthavn. En liste over CPHs samarbejdspartnere og deres produkter er altid tilgængelig på cph.dk. Du kan altid tilbagekalde dit samtykke via link i kommunikationen. Læs i øvrigt <a href='https://www.cph.dk/vilkar-og-betingelser/privatliv' target='_blank'>CPHs privatlivspolitik</a>"
                }]
        }`)

    return data
  }
  setReceiptShouldTrack = (value) => {
    this.setState({ receiptShouldTrack: value })
  }

  showGlobalSpinner = (value, callback) => {
    this.setState({ ajaxSpinnerActive: value }, callback)
  }

  updateCheckoutState = (key, value, requiredFields) => {
    this.setState({ [key]: value }, () => this.updateCheckoutErrorsValues(key, value, requiredFields))
  }

  updateCheckoutErrorsRequiredFields = (fields) => {
    const { checkoutErrors } = this.state
    let newCheckoutErrors = checkoutErrors
    newCheckoutErrors = { ...newCheckoutErrors, ...fields }
    this.setState({ checkoutErrors: newCheckoutErrors })
  }

  updateCheckoutErrorsValues = (key, value, requiredFields) => {
    const { checkoutErrors } = this.state
    let newCheckoutErrors = { ...checkoutErrors, showErrors: false }
    if (typeof value === "object") {
      Object.keys(value).forEach((key) => {
        if (Object.hasOwn(newCheckoutErrors, key)) {
          if (key === "email") {
            newCheckoutErrors[key] = emailValidatingRegex.test(value[key]) ? false : true
            newCheckoutErrors["appleRelayEmail"] = !appleRelayRegex.test(value[key]) ? false : true
            newCheckoutErrors["specialCharsEmail"] = !specialCharsRegex.test(value[key]) ? false : true
            if (this.state.affiliateCode === "cpp") {
              newCheckoutErrors["cphEmail"] = cphEmailRegex.test(value[key]) ? false : true
            }
            //!billingAddress.email.match(/(?!.*\.\.)(^[^\.][^@\s]+@[^@\s]+\.[^@\s\.]+$)/g)
          } else if (key === "mobilePhone") {
            newCheckoutErrors["mobilePhoneFormat"] = phoneRegex.test(value[key]) ? false : true
          } else {
            let newValue = false
            if (typeof value[key] === "boolean") {
              newValue = value[key] ? false : true
            } else {
              newValue = value[key] && value[key].length > 0 ? false : true
            }
            newCheckoutErrors[key] = newValue
          }
        }
      })
    } else if (Object.hasOwn(newCheckoutErrors, key)) {
      let newValue = false
      if (typeof value === "boolean") {
        newValue = value ? false : true
      } else {
        newValue = value.length > 0 ? false : true
      }
      newCheckoutErrors[key] = newValue
    }
    newCheckoutErrors = { ...newCheckoutErrors, ...requiredFields }
    this.setState({ checkoutErrors: newCheckoutErrors })
  }

  loadLinkedFromQueryParams() {
    const queryParam = QueryString.parse(this.props.location.search)

    if (queryParam.forgotreservation && !this.state.forgotReferenceModalActive) this.setState({ forgotReferenceModalActive: true })
  }

  loadFromQueryParams() {
    if (this.state.error) return // avoid indefinate loop on bad guid

    const queryParam = QueryString.parse(this.props.location.search)
    //if user has been through ?emailUpgradeGuid endpoint
    if (queryParam.isUpgrade) {
      storageHelper.setToSessionStorage("emailUpgradeGuid", queryParam.cfguid)

      if (queryParam.cfguid && !this.state.hasLoadedUpgrade) {
        this.handleEmailOfferUpgrade(queryParam.cfguid)
        this.setState({ hasLoadedUpgrade: true })
      }
    }

    //if user comes through from ?emailUpgradeGuid endpoint
    const emailUpgradeGuid = queryParam.emailUpgradeGuid
    if (emailUpgradeGuid && !this.state.hasLoadedUpgrade) {
      if (emailUpgradeGuid !== this.state.emailUpgradeGuid) {
        // we only have querystring - populate object
        this.handleEmailOfferUpgrade(emailUpgradeGuid)
        this.setState({ hasLoadedUpgrade: true })
      }
      return
    }

    const bookingGuid = queryParam.bguid
    if (bookingGuid && !this.state.loadingGetCartError) {
      if (!this.state.bookingResult || this.state.bookingResult.booking.guid !== bookingGuid) {
        // if cart is not in state fetch it - this can happen on user F5-reload
        if (this.props.location.pathname === path.EXTRA_SERVICES() || this.props.location.pathname === path.CHECKOUT()) {
          this.getCart(bookingGuid, (res) => {
            this.findExtrasForBooking(res.product.id, this.getArrivalData(), this.getDepartureData(), bookingGuid, this.state.voucher)
            this.findUpsaleForBooking(bookingGuid)
          })
        } else {
          this.getCart(bookingGuid)
        }
      }
    }

    const changeFromBookingGuid = queryParam.cfguid

    if (changeFromBookingGuid && !this.state.loadingLoadChangeFromBookingError) {
      if (changeFromBookingGuid !== this.state.changeFromBookingGuid || !this.state.changeFromBooking) {
        // we only have querystring - populate object
        this.loadChangeFromBooking(changeFromBookingGuid)
        if (this.props.location.pathname === path.CHECKOUT()) {
          // handle further loading from the query string:
          // replay the ammendment operation -> changeupgrade
          const productId = queryParam.parkingProductId
          if (productId) this.handleReservation(productId)
        }
      }
    }
  }

  loadExtensionFromQueryParams() {
    if (window.location.href.includes("extend-time") || window.location.href.includes("extend-checkout")) {
      const queryParam = QueryString.parse(this.props.location.search)
      const { cfguid, dd, dt, reference, email } = queryParam
      if (!cfguid || !dd || !dt) return
      this.performChangeBookingExitTime(cfguid, dd, dt, reference, email, true)
    }
  }

  loadAmendmentFromQueryParams() {
    const queryParam = QueryString.parse(this.props.location.search)
    const { email, reference } = queryParam
    if (!email || !reference) return
    this.findBooking(email, reference)
  }

  handleCurrentStep = (step) => {
    this.setState({ currentStep: step })
  }

  handleLogOut = () => {
    const returnUrl = this.props.location.pathname + this.props.location.search
    this.props.cookies.set(cookieNames.POST_LOGOUT_RETURN_URL, encodeURI(returnUrl), { path: "/" })
    window.location.href = "/IdpImplicitFlow/Logout"
  }

  componentDidMount() {
    this.setLoginState()
    this.loadAmendmentFromQueryParams()
    this.loadExtensionFromQueryParams()
    this.loadFromQueryParams()
    this.loadLinkedFromQueryParams()
    this.setState({ emailUpgradeGuid: storageHelper.getFromSessionStorage("emailUpgradeGuid") })
  }

  handleReasons = () => {
    const queryParam = QueryString.parse(this.props.location.search)

    if (queryParam.reason === "AuthorizationFailed") {
      this.genericModalOpen(
        queryParam.pbs && queryParam.pbs === 116
          ? config.get("textKeys.dialog.paymentInsufficientFunds") ||
              "<h3>Fejl ved betaling</h3><p>Der er ikke dækning på kortet, venligst prøv igen med andet kreditkort</p>"
          : "<h3>Fejl ved betaling</h3><p>Der er sket en fejl, vi kunne ikke godkende din betaling. Kontakt venligst kundeservice</p>",
      )
    }
    if (queryParam.reason === "NotAuthorized") {
      this.genericModalOpen(
        config.get("textKeys.dialog.paymentNotAuthorized") ||
          "<h3>Fejl ved betaling</h3><p>Der er sket en fejl, vi kunne ikke godkende din betaling. Kontakt venligst kundeservice</p>",
      )
    }
    if (queryParam.reason === "AlreadyConfirmed") {
      this.genericModalOpen(
        config.get("textKeys.dialog.paymentAlreadyConfirmed") ||
          "<h3>Fejl ved betaling</h3><p>Bookingen er allerede betalt, du vil modtage en bekræftelse om få minutter</p>",
      )
    }
    if (queryParam.reason === "BookingExpired") {
      this.genericModalOpen(
        config.get("textKeys.dialog.paymentBookingExpired") ||
          "<h3>Fejl ved betaling</h3><p>Bookingen er ikke længere gyldig, venligst opret en ny booking</p>",
      )
    }
    if (queryParam.reason === "Cancelled by User") {
      this.genericModalOpen(
        config.get("textKeys.dialog.paymentCancelledByUser") || "<h3>Fejl ved betaling</h3><p>Du har afbrudt betalingen, venligst prøv igen</p>",
      )
    }
    if (queryParam.reason === "MaxTriesReached") {
      this.genericModalOpen(
        config.get("textKeys.dialog.paymentMaxTriesReached") ||
          "<h3>Fejl</h3><p>Vi har i øjeblikket problemer med systemet. Du vil modtage en bekræftelsesmail " +
            "indenfor et par minutter. Modtager du ikke mailen, beder vi dig kontakte kundeservice, som vil hjælpe dig</p>",
      )
    }
  }

  setLoginState = () => {
    if (this.state.setLoginStateAttempted) {
      console.log("Escaping login attempt due to previous attempt failing")
      return
    }
    const cookieToken = this.props.cookies.get(cookieNames.ACCESS_TOKEN)
    const currentToken = window.localStorage.myAuthToken
    if (!cookieToken) {
      if (currentToken) {
        // session timed out or logout was forced
        delete window.localStorage.myAuthToken
        delete axios.defaults.headers.common["Authorization"]
        this.setState({ userAccountDetails: undefined })
      }
    } else if (cookieToken !== currentToken || !this.state.userAccountDetails) {
      // new token arrived or state is not loaded
      window.localStorage.myAuthToken = cookieToken
      axios.defaults.headers.common["Authorization"] = "Bearer " + cookieToken
      this.loadUserAccountDetails()
      this.setState({ setLoginStateAttempted: true })
    }
  }

  isLoggedIn = () => {
    const cookieToken = this.props.cookies.get(cookieNames.ACCESS_TOKEN)
    return !!cookieToken
  }

  componentDidUpdate() {
    this.setLoginState()
    this.loadFromQueryParams()
    if (this.state.isLoaded && !this.state.hasScrolled) {
      if (window.location.hash === "#all-options") {
        this.setState({ hasScrolled: true, showMapInitially: false }, () => {
          requestAnimationFrame(() => {
            this.scrollToElement()
          })
        })
      }
    }
  }

  getArrivalData = () => {
    const { arrivalDate, arrivalTime } = this.state
    if (!arrivalDate || !arrivalTime) return null
    return `${arrivalDate} ${arrivalTime}`
  }

  getDepartureData = () => {
    const { departureDate, departureTime } = this.state
    if (!departureDate || !departureTime) return null
    return `${departureDate} ${departureTime}`
  }

  getExtraPrice = (extra, booking) => {
    if (!extra) return 0
    if (!booking) return 0
    const itemExtra = booking.items.extras.find((e) => e.extraId === extra.id)
    return (itemExtra && itemExtra.offerLines && itemExtra.offerLines[0].originalAmount) || 0
  }

  extraServiceModalInfoToogle = (extraServiceModalProduct) => {
    this.setState({ extraServicesInfoModalActive: !this.state.extraServicesInfoModalActive, extraServiceModalProduct })
  }

  extraServicesDetailsModalToggle = (extraServiceModalProduct, extraServiceModalProductOffer, extraServiceModalContentVariant) => {
    this.setState({
      extraServicesDetailsModalActive: !this.state.extraServicesDetailsModalActive,
      extraServiceModalProduct,
      extraServiceModalProductOffer,
      extraServiceModalContentVariant,
    })
  }

  extraServiceModalSelectorToogle = (extraServiceModalProduct) => {
    this.setState({ extraServiceModalSelectorActive: !this.state.extraServiceModalSelectorActive, extraServiceModalProduct })
  }

  extraServicesAcceptConditionsModalActivate = (extraServiceModalProduct, extraServiceModalProductSku, extraServiceModalContentVariant) => {
    this.setState({
      extraServicesAcceptConditionsModalActive: true,
      extraServiceModalProduct,
      extraServiceModalProductSku,
      extraServiceModalContentVariant,
    })
  }

  extraServicesAcceptConditionsModalClose = () => {
    this.setState({ extraServicesAcceptConditionsModalActive: false })
  }

  extraServicesAcceptConditionsModalCancel = () => {
    this.setState({
      extraServicesAcceptConditionsModalActive: false,
      extraServiceModalProduct: undefined,
      extraServiceModalProductSku: undefined,
      extraServiceModalContentVariant: undefined,
    })
  }

  updateAmmendmentEmailValue = (evt) => {
    this.setState({
      ammendmentEmail: evt.target.value,
    })
  }

  updateAmmendmentReferenceValue = (evt) => {
    this.setState({
      ammendmentReference: evt.target.value,
    })
  }

  removeBooking = () => {
    this.setState({ bookingResult: undefined, bookingExtras: undefined })
  }

  parkingTimeModalToogle = () => {
    this.setState({ parkingTimeModalActive: !this.state.parkingTimeModalActive })
  }
  amendForgotReferenceModalToogle = () => {
    this.setState({ forgotReferenceModalActive: !this.state.forgotReferenceModalActive })
  }
  paymentModalShow = () => {
    this.setState({ paymentModalActive: true })
  }
  paymentModalHide = () => {
    this.setState({ paymentModalActive: false })
  }
  paymentModalToggle = () => {
    this.setState({ paymentModalActive: !this.state.paymentModalActive })
  }
  createQueryStrings(data) {
    let queryString = ""
    if (!data) return queryString
    Object.keys(data).forEach((key) => {
      const operator = queryString ? "&" : "?"
      if (data[key]) queryString += `${operator}${key}=${data[key]}`
    })
    return queryString
  }

  sort = (sortingKey, allProducts, cfProduct = undefined, isAmendment = false) => {
    switch (sortingKey) {
      case "price":
        return this.priceSorting(allProducts)
      case "freeSpaces":
        return this.spacesSorting(allProducts)
      case "amendmentSort":
        return this.amendmentSorting(allProducts, cfProduct, isAmendment)
      case "distance":
        break
      default:
        break
    }
    return allProducts
  }

  handleSorting = (sortingKey, changeFromBooking = undefined, isAmendment = false) => {
    const { allProducts } = this.state
    switch (sortingKey) {
      case "price":
        this.handlePriceSorting(allProducts)
        break
      case "freeSpaces":
        this.handleSpacesSorting(allProducts)
        break
      case "upgradeOption":
        this.handleAmendmentSorting(allProducts, changeFromBooking, isAmendment)
        break
      case "distance":
        break
      default:
        this.handleSearchWithSorting(sortingKey)
    }
  }
  handleSearchWithSorting = (sortingKey) => {
    const { arrivalDate, arrivalTime, departureDate, departureTime, voucher, affiliateCode } = this.state
    this.performParkingSearch(arrivalDate, arrivalTime, departureDate, departureTime, voucher, affiliateCode, true, sortingKey)
  }

  handlePriceSorting = (allProducts) => {
    const sortedProducts = this.priceSorting(allProducts)
    this.setState({ allProducts: sortedProducts })
  }

  handleSpacesSorting = (allProducts) => {
    const sortedProducts = this.spacesSorting(allProducts)
    this.setState({ allProducts: sortedProducts })
  }

  handleAmendmentSorting = (allProducts, cfProduct = undefined, isAmendment = false) => {
    const sortedProducts = this.amendmentSorting(allProducts, cfProduct, isAmendment)
    this.setState({ allProducts: sortedProducts })
  }

  amendmentSorting = (allProducts, cfProduct, isAmendment) => {
    if (isAmendment) {
      let hasExtras = false
      hasExtras = cfProduct.booking?.items?.extras[0]?.offerLines[0]?.amount ? true : false
      let extrasAmount = 0
      if (hasExtras) {
        extrasAmount = cfProduct.booking.items.extras[0].offerLines[0].amount
      }

      let positiveProducts = allProducts.filter(
        (x) =>
          (x.result.memberPrice > 0 ? x.result.memberPrice : x.result.totalPrice) - (cfProduct.booking.price - extrasAmount) >= 0 &&
          !x.product.isSoldOut,
      )
      positiveProducts = positiveProducts.sort((a, b) => {
        return (a.result.memberPrice > 0 ? a.memberPrice : a.result.totalPrice) - b.result.totalPrice
      })

      let negativeProducts = allProducts.filter(
        (x) =>
          (x.result.memberPrice > 0 ? x.result.memberPrice : x.result.totalPrice) - (cfProduct.booking.price - extrasAmount) < 0 &&
          !x.product.isSoldOut,
      )
      negativeProducts = negativeProducts
        .sort((a, b) => {
          return (a.result.memberPrice > 0 ? a.memberPrice : a.result.totalPrice) - b.result.totalPrice
        })
        .reverse()

      let stocklessProducts = allProducts.filter((x) => x.product.isSoldOut)
      stocklessProducts = stocklessProducts.sort((a, b) => {
        return (a.result.memberPrice > 0 ? a.memberPrice : a.result.totalPrice) - b.result.totalPrice
      })

      const emulsifiedProductList = positiveProducts.concat(negativeProducts, stocklessProducts)

      return emulsifiedProductList
    }
    return allProducts
  }

  priceSorting = (allProducts) => {
    return allProducts.sort((a, b) => a.result.totalPrice - b.result.totalPrice)
  }

  spacesSorting = (allProducts) => {
    return allProducts.sort((a, b) => a.product.isSoldOut - b.product.isSoldOut)
  }

  saveGuidToSessionStorage(res) {
    sessionStorage.setItem("CPH:BOOKING_GUID", res.booking.guid)
  }

  /* payment state handling for tracking purposes */

  handleSelectedPaymentType = (payload) => {
    const { selectedPaymentType } = this.state
    const newSelectedPaymentType = selectedPaymentType
    if (typeof payload === "string") {
      newSelectedPaymentType.paymentType = payload
    } else if (payload && selectedPaymentType !== payload.displayname) {
      newSelectedPaymentType.cardType = payload.displayname
    }
    this.setState({ selectedPaymentType: newSelectedPaymentType })
  }

  getAllProductsFromReceipt = () => {
    return [
      {
        product: this.state.bookingResult.product,
        carPark: this.state.bookingResult.carPark,
      },
    ]
  }

  genericModalOpen = (html, callback) => {
    this.setState({
      genericModalActive: true,
      genericModalBody: html,
      genericModalCallback: callback,
    })
  }

  genericModalClose = (callback) => {
    this.setState(
      {
        genericModalActive: false,
        genericModalBody: undefined,
        genericModalCallback: undefined,
      },
      callback,
    )
  }

  trackError = (text, error, errorType) => {
    const userId = cookieHelper.getUserId(this.props)

    const data = {
      event: "track-event",
      eventCategory: "parking flow",
      eventAction: "error",
      eventLabel: this.getErrorLabel(error, errorType, text),
      eventValue: 0,
      eventNoninteraction: true,
      userParkingArrivalDate: this.state.arrivalDate,
      userParkingDepartureDate: this.state.departureDate,
      pageBusinessunit: "parking",
      logged_in: this.isLoggedIn(),
    }
    if (userId) data.userId = userId
    window.dataLayer.push(data)
  }
  trackSoldOutRate = (allProducts) => {
    const { arrivalDate, departureDate } = this.state
    const amountOfProducts = allProducts.length
    let amountOfSoldOutProducts = 0
    allProducts.forEach((item) => {
      if (item.product.isSoldOut) {
        amountOfSoldOutProducts++
      }
    })
    const userId = cookieHelper.getUserId(this.props)
    const data = {
      event: "track-event",
      eventCategory: "parking flow",
      eventAction: "sold out rate",
      eventLabel: `${amountOfSoldOutProducts}/${amountOfProducts}`,
      eventValue: parseFloat(amountOfSoldOutProducts / amountOfProducts).toFixed(2),
      eventNoninteraction: true,
      userParkingArrivalDate: arrivalDate,
      userParkingDepartureDate: departureDate,
      pageBusinessunit: "parking",
      logged_in: this.isLoggedIn(),
    }
    if (userId) data.userId = userId
    window.dataLayer.push(data)
  }
  getErrorLabel = (error, errorType, text) => {
    switch (errorType) {
      case "search":
        return `search - ${text}`
      case "extra services":
        return `extra services - ${text}`
      case "payment":
        return `payment - ${text}`
      case "payment gateway":
        return `payment gateway - ${text}`
      case "date":
        return `date - ${text}`
      default:
        return error
    }
  }
  /*
     DATA PROVIDERS
   */

  axiosErrorHandler = (error, errorState = {}, errorHandlers = {}) => {
    console.log("axiosErrorHandler", error)
    const textKeys = config.get("textKeys.dialog") || {}
    if (!error.response) {
      const text = textKeys.unknownError || `<h3>Fejl</h3><p>Der er sket en uventet fejl</p>`
      this.setState(errorState, errorHandlers.noResponse ? errorHandlers.noResponse(error.response?.data) : this.genericModalOpen(text))
      return text
    }

    // parse by code

    if (error.response.status === 400) {
      const text =
        (textKeys.badRequestError && textKeys.badRequestError.replace("${", "{").replace("{message}", error.response.data.message)) ||
        `<h3>Fejl</h3><p>${error.response.data.message}</p>`

      this.setState(errorState, errorHandlers.badRequest ? errorHandlers.badRequest(error.response.data.message) : this.genericModalOpen(text))
      return text
    }

    /* old message string based error handling*/

    if (error.response.status === 404 || (error.response.data && error.response.data.message === "NotFound")) {
      const text = textKeys.notFoundError || `<h3>Fejl</h3><p>Der er en fejl i linket, hvis du har kopieret det ind så prøv igen</p>`
      this.setState(errorState, errorHandlers.notFound ? errorHandlers.notFound(error.response.data) : this.genericModalOpen(text))
      return text
    }

    if (error.response.status === 405 || (error.response.data && error.response.data.message === "MethodNotAllowed")) {
      const text =
        textKeys.sessionExpiredError ||
        `<h3>Fejl</h3><p>Din session er udløbet du har været inaktiv for længe, prøv at genindlæse siden ved at trykke på CTRL+R</p>`
      this.setState(errorState, errorHandlers.methodNotAllowed ? errorHandlers.methodNotAllowed(error.response.data) : this.genericModalOpen(text))
      return text
    }

    console.log(JSON.stringify(error))
    if (error.response && error.response.data.message && error.response.data.message) {
      const text =
        (textKeys.standardError && textKeys.standardError.replace("${", "{").replace("{message}", error.response.data.message)) ||
        `<h3>Fejl</h3><p>${error.response.data.message}</p>`
      this.genericModalOpen(text)
    }
    this.setState(errorState)
  }

  loadUserAccountDetails = () => {
    if (!this.state.loadingContactDetails) {
      this.setState({ loadingContactDetails: true, loadingContactDetailsError: undefined }, () => {
        axios
          .get(endpoint.ACCOUNT_DETAILS())
          .then((res) => res.data)
          .then((userAccountDetails) => {
            let { billingAddress, vechicleInformation, marketingConsentContent } = this.state
            let newbillingAddress = billingAddress
            let newVehicleInformation = vechicleInformation
            let newMarketingConsentContent = {
              header: marketingConsentContent.header,
              items: [],
            }

            // CPH-5030 hiding is on purpose NOT linked to specific versions, as a version update would disturb the checkout funnel
            marketingConsentContent.items.map((i) => {
              let dontDisplay =
                (i.consentId === "Parking Consent" && userAccountDetails?.ContactDetails?.ParkingServicesPermission) ||
                (i.consentId === "Marketing Consent" && userAccountDetails?.ContactDetails?.NewsletterSubscription)

              newMarketingConsentContent.items.push({ ...i, dontDisplay })
            })

            if (userAccountDetails && userAccountDetails.ContactDetails && !billingAddress.email) {
              newbillingAddress = {
                firstName: userAccountDetails.ContactDetails.FirstName || "",
                lastName: userAccountDetails.ContactDetails.LastName || "",
                email: userAccountDetails.EmailAddress || "",
                mobilePhone: userAccountDetails.ContactDetails.MobilePhone || "",
              }
              if (userAccountDetails.ContactDetails.Address.CountryCode) {
                newbillingAddress.countryId = countryHelper.getCountryID(userAccountDetails.ContactDetails.Address.CountryCode)
                newbillingAddress.country = countryHelper.getCountryNameByCode(userAccountDetails.ContactDetails.Address.CountryCode)
              }
              if (userAccountDetails.ContactDetails.Address.PostalCode) {
                newbillingAddress.postcode = userAccountDetails.ContactDetails.Address.PostalCode
              }
              if (userAccountDetails.ContactDetails.Address.City) {
                newbillingAddress.town = userAccountDetails.ContactDetails.Address.City
              }
              newVehicleInformation = {
                vehicleColour: userAccountDetails.ContactDetails.VehicleColour,
                vehicleMake: userAccountDetails.ContactDetails.VehicleMake,
                vehicleModel: userAccountDetails.ContactDetails.VehicleModel,
                vehicleRegistrationNumber: userAccountDetails.ContactDetails.VehicleRegistrationNumber,
              }
            }
            this.setState({
              marketingConsentContent: newMarketingConsentContent,
              userAccountDetails,
              billingAddress: { ...billingAddress, ...newbillingAddress },
              vechicleInformation: { ...vechicleInformation, ...newVehicleInformation },
              loadingContactDetails: false,
              loadingContactDetailsError: undefined,
            })
          })
          .catch((error) => {
            this.axiosErrorHandler(error, {
              ajaxSpinnerActive: false,
              loadingContactDetails: false,
              loadingContactDetailsError: error,
            })
            // this is based on a mixup of uat and prod tokens, so remove the cookie to avoid loop
            this.props.cookies.remove(cookieNames.ACCESS_TOKEN)
          })
      })
    }
  }

  resendNextAvailableBookingConfirmation = (email) => {
    if (!this.state.loadingresendNextAvailableBookingConfirmation) {
      this.setState(
        {
          ajaxSpinnerActive: true,
          loadingresendNextAvailableBookingConfirmation: true,
          loadingresendNextAvailableBookingConfirmationError: undefined,
        },
        () => {
          axios
            .get(endpoint.RESEND_NEXT_AVAILABLE_BOOKING_CONFIRMATION() + "?email=" + email)
            .then((res) => res.data)
            .then(() => {
              this.genericModalOpen(
                (config.get("textKeys.dialog.emailActivation") &&
                  config.get("textKeys.dialog.emailActivation").replace("${", "{").replace("{email}", email)) ||
                  `<h3>Genfremsendelse aktiveret</h3><p>Du vil i løbet af et par minutter modtage en ny kopi af alle fremtidige bookinger foretaget af <strong>${email}</strong></p>`,
              )
              this.setState({
                ajaxSpinnerActive: false,
                forgotReferenceModalActive: false,
                loadingresendNextAvailableBookingConfirmation: false,
                loadingresendNextAvailableBookingConfirmationError: undefined,
              })
            })
            .catch((error) => {
              this.axiosErrorHandler(error, {
                ajaxSpinnerActive: false,
                loadingresendNextAvailableBookingConfirmation: false,
                loadingresendNextAvailableBookingConfirmationError: error,
              })
            })
        },
      )
    }
  }
  resendBookingReceipt = (guid) => {
    if (!this.state.loadingResendBookingReceipt) {
      this.setState(
        {
          ajaxSpinnerActive: true,
          loadingResendBookingReceipt: true,
          loadingResendBookingReceiptError: undefined,
        },
        () => {
          axios
            .get(endpoint.RESEND_BOOKING_RECEIPT(guid))
            .then((res) => res.data)
            .then(() => {
              this.genericModalOpen(
                config.get("textKeys.dialog.emailResendReceipt") ||
                  `<h3>Genfremsendelse aktiveret</h3><p>Du vil i løbet af et par minutter modtage en ny kopi af din kvitteringsmail</p>`,
              )
              this.setState({
                ajaxSpinnerActive: false,
                forgotReferenceModalActive: false,
                loadingResendBookingReceipt: false,
                loadingResendBookingReceiptError: undefined,
              })
            })
            .catch((error) => {
              this.axiosErrorHandler(error, {
                ajaxSpinnerActive: false,
                loadingResendBookingReceipt: false,
                loadingResendBookingReceiptError: error,
              })
            })
        },
      )
    }
  }

  performChangeBookingSearch = (
    changeFromBookingResult,
    arrivalDate,
    arrivalTime,
    departureDate,
    departureTime,
    voucher = "",
    affiliateCode = "",
    reference,
    email,
    replaceHistory,
    sorting = "",
  ) => {
    if (!this.state.loadingPerformChangeBookingSearch) {
      const changeFromBookingGuid = changeFromBookingResult.booking.guid
      this.setState(
        {
          ajaxSpinnerActive: true,
          loadingPerformChangeBookingSearch: true,
          loadingPerformChangeBookingSearchError: undefined,
        },
        () => {
          console.debug("performChangeBookingSearch")
          axios
            .get(
              endpoint.FIND_PARKING_CHANGE(changeFromBookingGuid) +
                "?arrival=" +
                encodeURIComponent(`${arrivalDate} ${arrivalTime}`) +
                "&departure=" +
                encodeURIComponent(`${departureDate} ${departureTime}`) +
                "&promotionCode=" +
                encodeURIComponent(voucher) +
                "&affiliateCode=" +
                encodeURIComponent(affiliateCode) +
                sorting,
            )
            .then((res) => res.data)
            .then((searchResult) => {
              const result = searchResult.productCategories
              const parkingList = config.get("textKeys.parkingList")
              var allProducts = []
              if (result && result.length > 0) {
                result.forEach((element) => {
                  allProducts = [...allProducts, ...element.products]
                })
              }
              if (parkingList.sorting && parkingList.sorting && parkingList.sorting.options[0]) {
                allProducts = this.sort(parkingList.sorting.options[0].sortingKey, allProducts, this.props.isAmendment)
              }
              if (allProducts.length > 0) this.trackSoldOutRate(allProducts)
              this.setState({
                // changeFromBooking: changeFromBookingResult,
                isLoaded: true,
                globals: searchResult.searchResultGlobals,
                productCategories: result,
                allProducts,
                arrivalDate,
                arrivalTime,
                departureDate,
                departureTime,
                voucher,
                durationDays: Math.ceil(Math.abs(new Date(departureDate).getTime() - new Date(arrivalDate).getTime()) / (1000 * 60 * 60 * 24)),
                flightInformation: {
                  outboundFlightDate: arrivalDate,
                  inboundFlightDate: departureDate,
                },
                ajaxSpinnerActive: false,
                loadingPerformChangeBookingSearch: false,
                // changeFromBookingGuid: changeFromBookingGuid
              })

              // console.log(changeFromBookingResult);
              if (changeFromBookingResult) {
                this.handleAmendmentSorting(allProducts, changeFromBookingResult, true)
              } else {
                this.handleSpacesSorting(allProducts)
              }

              const query = {
                ad: arrivalDate,
                at: arrivalTime,
                dd: departureDate,
                dt: departureTime,
                voucher,
                affiliate: affiliateCode,
                cfguid: changeFromBookingGuid,
                email,
                reference,
              }
              if (replaceHistory) {
                this.props.history.replace({
                  pathname: path.SEARCH_AMMEND_BOOKING(),
                  search: this.createQueryStrings(query),
                })
              } else {
                this.props.history.push({
                  pathname: path.SEARCH_AMMEND_BOOKING(),
                  search: this.createQueryStrings(query),
                })
              }
              this.removeBooking()
            })
            .catch((error) => {
              const text = this.axiosErrorHandler(error, {
                ajaxSpinnerActive: false,
                loadingPerformChangeBookingSearch: false,
                loadingPerformChangeBookingSearchError: error,
              })
              if (text) this.trackError(text.replace(/<\/?[^>]+(>|$)/g, " "), error, "search")
            })
        },
      )
    }
  }

  performChangeBookingTime = (
    changeFromBookingResult,
    arrivalDate,
    arrivalTime,
    departureDate,
    departureTime,
    voucher = "",
    affiliateCode = "",
    reference,
    email,
    replaceHistory,
    sorting = "",
  ) => {
    if (!this.state.loadingPerformChangeBookingSearch) {
      const changeFromBookingGuid = changeFromBookingResult.booking.guid
      this.setState(
        {
          ajaxSpinnerActive: true,
          loadingPerformChangeBookingSearch: true,
          loadingPerformChangeBookingSearchError: undefined,
        },
        () => {
          console.debug("performChangeBookingSearch")
          axios
            .get(
              endpoint.FIND_PARKING_CHANGE_TIMEONLY(changeFromBookingGuid) +
                "?arrival=" +
                encodeURIComponent(`${arrivalDate} ${arrivalTime}`) +
                "&departure=" +
                encodeURIComponent(`${departureDate} ${departureTime}`) +
                "&promotionCode=" +
                encodeURIComponent(voucher) +
                "&affiliateCode=" +
                encodeURIComponent(affiliateCode) +
                sorting,
            )
            .then((res) => res.data)
            .then((searchResult) => {
              const result = searchResult.productCategories
              var allProducts = []
              if (result && result.length > 0)
                result.forEach((element) => {
                  allProducts = [...allProducts, ...element.products]
                })
              if (allProducts.length > 0) this.trackSoldOutRate(allProducts)

              this.setState({
                // changeFromBooking: changeFromBookingResult,
                isLoaded: true,
                globals: searchResult.searchResultGlobals,
                productCategories: result,
                allProducts,
                arrivalDate,
                arrivalTime,
                departureDate,
                departureTime,
                voucher,
                durationDays: Math.ceil(Math.abs(new Date(departureDate).getTime() - new Date(arrivalDate).getTime()) / (1000 * 60 * 60 * 24)),
                flightInformation: {
                  outboundFlightDate: arrivalDate,
                  inboundFlightDate: departureDate,
                },
                ajaxSpinnerActive: false,
                loadingPerformChangeBookingSearch: false,
                // changeFromBookingGuid: changeFromBookingGuid
              })

              this.handleSpacesSorting(allProducts)

              const query = {
                ad: arrivalDate,
                at: arrivalTime,
                dd: departureDate,
                dt: departureTime,
                voucher,
                affiliate: affiliateCode,
                cfguid: changeFromBookingGuid,
                email,
                reference,
              }
              if (replaceHistory) {
                this.props.history.replace({
                  pathname: path.AMMEND_EDIT_TIME(),
                  search: this.createQueryStrings(query),
                })
              } else {
                this.props.history.push({
                  pathname: path.AMMEND_EDIT_TIME(),
                  search: this.createQueryStrings(query),
                })
              }
              this.removeBooking()

              // // if response contains only one product, then auto select and go to confirmation and checkout
              // if (allProducts.length === 1) {
              //   this.handleReservation(allProducts[0].product.id, null)
              // }
              // else {
              //   // set state to show

              // }
            })
            .catch((error) => {
              const text = this.axiosErrorHandler(error, {
                ajaxSpinnerActive: false,
                loadingPerformChangeBookingSearch: false,
                loadingPerformChangeBookingSearchError: error,
              })
              if (text) this.trackError(text.replace(/<\/?[^>]+(>|$)/g, " "), error, "search")
            })
        },
      )
    }
  }

  //focus
  performChangeBookingExitTime = (changeFromBookingGuid, departureDate, departureTime, reference, email, replaceHistory) => {
    if (this.state.bookingExtension) {
      const { departureDate: cfDepartureDate, departureTime: cfDepartureTime } = this.state.bookingExtension.booking
      if (departureDate === cfDepartureDate && departureTime === cfDepartureTime) {
        const query = {
          dd: departureDate,
          dt: departureTime,
          cfguid: changeFromBookingGuid,
          email: email,
          reference: reference,
        }
        if (replaceHistory) {
          this.props.history.replace({
            pathname: path.AMMEND_EXTEND_TIME(),
            search: this.createQueryStrings(query),
          })
        } else {
          this.props.history.push({
            pathname: path.AMMEND_EXTEND_TIME(),
            search: this.createQueryStrings(query),
          })
        }
        this.setState({
          bookingExtension: undefined,
        })
        return
      }
    }

    if (this.state.manageBookingResult) {
      if (
        departureDate !== this.state.manageBookingResult.booking.departureDate ||
        departureTime !== this.state.manageBookingResult.booking.departureTime
      ) {
        if (!this.state.loadingPerformChangeBookingSearch) {
          this.setState(
            {
              ajaxSpinnerActive: true,
              loadingPerformChangeBookingExitTime: true,
              loadingPerformChangeBookingExitTimeError: undefined,
            },
            () => {
              console.debug("performChangeBookingExitTime")
              axios
                .get(
                  endpoint.FIND_BOOKING_EXTENSION_BY_GUID(changeFromBookingGuid) +
                    "?newDeparture=" +
                    encodeURIComponent(`${departureDate}T${departureTime}`),
                )
                .then((res) => {
                  const query = {
                    dd: departureDate,
                    dt: departureTime,
                    cfguid: changeFromBookingGuid,
                    email: email,
                    reference: reference,
                    extensionId: res.data?.parkingExtension?.extensionId,
                  }
                  if (replaceHistory) {
                    this.props.history.replace({
                      pathname: path.AMMEND_EXTEND_TIME(),
                      search: this.createQueryStrings(query),
                    })
                  } else {
                    this.props.history.push({
                      pathname: path.AMMEND_EXTEND_TIME(),
                      search: this.createQueryStrings(query),
                    })
                  }
                  this.setState({
                    bookingExtension: res.data,
                    isLoaded: true,
                    ajaxSpinnerActive: false,
                    loadingPerformChangeBookingExitTime: false,
                  })
                })
                .catch((error) => {
                  const text = this.axiosErrorHandler(error, {
                    ajaxSpinnerActive: false,
                    loadingPerformChangeBookingExitTime: false,
                    loadingPerformChangeBookingExitTimeError: error,
                  })
                  if (text) this.trackError(text.replace(/<\/?[^>]+(>|$)/g, " "), error, "search")
                })
            },
          )
        }
      }
    }
  }

  performParkingSearch = (
    arrivalDate,
    arrivalTime,
    departureDate,
    departureTime,
    voucher,
    affiliateCode,
    replaceHistory,
    errorType = "search",
    sorting = "",
    isAmendment = false,
  ) => {
    const textKeys = config.get("textKeys.dialog") || {}
    let terminalProximityPriority = ""
    let cheapestFacilityPriority = ""
    let bestOfferFacilityPriority = ""

    const arrival = `${arrivalDate} ${arrivalTime}`
    const departure = `${departureDate} ${departureTime}`
    const arrivalDateTime = DateTime.fromFormat(arrival, "yyyy-MM-dd HH:mm")
    const departureDateTime = DateTime.fromFormat(departure, "yyyy-MM-dd HH:mm")

    const duration = departureDateTime.diff(arrivalDateTime, ["days"]).toObject()
    const days = Math.floor(duration.days)

    const isLoggedIn = this.isLoggedIn()
    const isShortDuration = days < 3

    // terminal proximity priority
    if (this.props.content.terminalProximityPriorityShortDuration && isShortDuration)
      if (this.props.content.terminalProximityPriorityShortDurationAffiliate && affiliateCode)
        terminalProximityPriority = this.props.content.terminalProximityPriorityShortDurationAffiliate
      else if (this.props.content.terminalProximityPriorityShortDurationLoggedIn && isLoggedIn)
        terminalProximityPriority = this.props.content.terminalProximityPriorityShortDurationLoggedIn
      else terminalProximityPriority = this.props.content.terminalProximityPriorityShortDuration
    else if (this.props.content.terminalProximityPriority)
      if (this.props.content.terminalProximityPriorityAffiliate && affiliateCode)
        terminalProximityPriority = this.props.content.terminalProximityPriorityAffiliate
      else terminalProximityPriority = this.props.content.terminalProximityPriority

    // cheapest facility priority
    if (this.props.content.cheapestFacilityPriorityShortDuration && isShortDuration)
      if (this.props.content.cheapestFacilityPriorityShortDurationAffiliate && affiliateCode)
        cheapestFacilityPriority = this.props.content.cheapestFacilityPriorityShortDurationAffiliate
      else if (this.props.content.cheapestFacilityPriorityShortDurationLoggedIn && isLoggedIn)
        cheapestFacilityPriority = this.props.content.cheapestFacilityPriorityShortDurationLoggedIn
      else cheapestFacilityPriority = this.props.content.cheapestFacilityPriorityShortDuration
    else if (this.props.content.cheapestFacilityPriority)
      if (this.props.content.cheapestFacilityPriorityAffiliate && affiliateCode)
        cheapestFacilityPriority = this.props.content.cheapestFacilityPriorityAffiliate
      else cheapestFacilityPriority = this.props.content.cheapestFacilityPriority

    // best offer priority
    if (this.props.content.bestOfferFacilityPriorityShortDuration && isShortDuration)
      if (this.props.content.bestOfferFacilityPriorityShortDurationAffiliate && affiliateCode)
        bestOfferFacilityPriority = this.props.content.bestOfferFacilityPriorityShortDurationAffiliate
      else if (this.props.content.bestOfferFacilityPriorityShortDurationLoggedIn && isLoggedIn)
        bestOfferFacilityPriority = this.props.content.bestOfferFacilityPriorityShortDurationLoggedIn
      else bestOfferFacilityPriority = this.props.content.bestOfferFacilityPriorityShortDuration
    else if (this.props.content.bestOfferFacilityPriority)
      if (this.props.content.bestOfferFacilityPriorityAffiliate && affiliateCode)
        bestOfferFacilityPriority = this.props.content.bestOfferFacilityPriorityAffiliate
      else bestOfferFacilityPriority = this.props.content.bestOfferFacilityPriority

    if (!this.state.loadingPerformParkingSearch) {
      this.setState(
        {
          ajaxSpinnerActive: true,
          loadingPerformParkingSearch: true,
          loadingPerformParkingSearchError: undefined,
        },
        () => {
          const url =
            endpoint.FIND_PARKING() +
            "?arrival=" +
            encodeURIComponent(arrival) +
            "&departure=" +
            encodeURIComponent(departure) +
            "&promotionCode=" +
            (voucher ? encodeURIComponent(voucher) : "") +
            "&affiliateCode=" +
            (affiliateCode ? encodeURIComponent(affiliateCode) : "") +
            "&terminalProximityPriority=" +
            encodeURIComponent(terminalProximityPriority) +
            "&cheapestFacilityPriority=" +
            encodeURIComponent(cheapestFacilityPriority) +
            "&bestOfferFacilityPriority=" +
            encodeURIComponent(bestOfferFacilityPriority) +
            sorting
          console.debug("calledbookingsearch: " + url)
          axios
            .get(url)
            .then((res) => res.data)
            .then((searchResult) => {
              const result = searchResult.productCategories
              var allProducts = []
              if (result && result.length > 0) {
                result.forEach((element) => {
                  allProducts = [...allProducts, ...element.products]
                })
              }

              const parkingList = config.get("textKeys.parkingList")
              if (parkingList.sorting && parkingList.sorting && parkingList.sorting.options[1] && !this.state.voucher) {
                if (parkingList.sorting.options.length >= 1) allProducts = this.sort(parkingList.sorting.options[1].sortingKey, allProducts)
              }
              if (allProducts.length > 0) {
                this.trackSoldOutRate(allProducts)

                // check if all products are sold out
                const amountOfProducts = allProducts.length
                let amountOfSoldOutProducts = 0
                allProducts.forEach((item) => {
                  if (item.product.isSoldOut) {
                    amountOfSoldOutProducts++
                  }
                })
                let notificationBanner = document.getElementsByClassName("notifications soldOutBanner")[0]
                if (notificationBanner) {
                  if (amountOfProducts === amountOfSoldOutProducts) {
                    notificationBanner.classList.remove("hide")
                  } else {
                    notificationBanner.classList.add("hide")
                  }
                  new Sticky({ el: document.querySelector(".parking-time-picker-wrapper") })
                }
              }

              if (voucher && !searchResult.searchResultGlobals.promotionName) {
                this.setState(
                  {
                    voucher: undefined,
                    ajaxSpinnerActive: false,
                    loadingPerformParkingSearch: false,
                  },
                  this.genericModalOpen(
                    (config.get("textKeys.dialog.voucherNotFound") &&
                      config.get("textKeys.dialog.voucherNotFound").replace("${", "{").replace("{voucher}", voucher)) ||
                      `<h3>Ukendt kampagnekode</h3><p>Den indtastede kampagnekode <strong>${voucher}</strong> kan ikke findes i systemet</p>`,
                  ),
                )
                return
              }
              this.setState({
                isLoaded: true,
                globals: searchResult.searchResultGlobals,
                productCategories: result,
                allProducts,
                arrivalDate,
                arrivalTime,
                departureDate,
                departureTime,
                voucher,
                durationDays: Math.ceil(Math.abs(new Date(departureDate).getTime() - new Date(arrivalDate).getTime()) / (1000 * 60 * 60 * 24)),
                flightInformation: {
                  outboundFlightDate: arrivalDate,
                  inboundFlightDate: departureDate,
                },
                ajaxSpinnerActive: false,
                loadingPerformParkingSearch: false,
                parkingHighlights: searchResult.productHighlights,
              })

              const query = {
                ad: arrivalDate,
                at: arrivalTime,
                dd: departureDate,
                dt: departureTime,
              }
              if (voucher) query.voucher = voucher
              if (affiliateCode) query.affiliate = affiliateCode
              if (this.state.changeFromBookingGuid) query.cfguid = this.state.changeFromBookingGuid
              if (this.state.ammendmentEmail) query.email = this.state.ammendmentEmail
              if (this.state.ammendmentReference) query.reference = this.state.ammendmentReference
              if (replaceHistory) {
                this.props.history.replace({
                  pathname: path.SEARCH(),
                  search: this.createQueryStrings(query),
                })
              } else {
                this.props.history.push({
                  pathname: path.SEARCH(),
                  search: this.createQueryStrings(query),
                })
              }
              this.removeBooking()
            })
            .catch((error) => {
              const text = this.axiosErrorHandler(
                error,
                {
                  ajaxSpinnerActive: false,
                  loadingPerformParkingSearch: false,
                  loadingPerformParkingSearchError: error,
                },
                {
                  badRequest: () => {
                    this.genericModalOpen(
                      textKeys.noBookingInThePast ||
                        `<h3>Tidsfristen er overskredet</h3><p>Du kan tidligst booke 1 timer før ønsket ankomsttidspunkt</p>`,
                    )
                  },
                },
              )
              if (text) this.trackError(text.replace(/<\/?[^>]+(>|$)/g, " "), error, errorType)
            })
        },
      )
    }
  }

  findBooking = (email, reference) => {
    if (!this.state.loadingFindBooking) {
      this.setState(
        {
          ajaxSpinnerActive: true,
          loadingFindBooking: true,
          findBookingError: undefined,
        },
        () => {
          axios
            .get(endpoint.FIND_BOOKING() + "?email=" + encodeURIComponent(email) + "&bookingReference=" + encodeURIComponent(reference))
            .then((res) => res.data)
            .then((result) => {
              // TODO: queryStringDiffersFromAmendedBooking
              let queryStringDiffersFromAmendedBooking = false
              const { arrivalDate, arrivalTime, departureDate, departureTime } = this.state
              if (arrivalDate !== result.booking.arrivalDate) queryStringDiffersFromAmendedBooking = true
              if (arrivalTime !== result.booking.arrivalTime) queryStringDiffersFromAmendedBooking = true
              if (departureDate !== result.booking.departureDate) queryStringDiffersFromAmendedBooking = true
              if (departureTime !== result.booking.departureTime) queryStringDiffersFromAmendedBooking = true
              // if(voucher!== result.booking.voucher) queryStringDiffersFromAmendedBooking = true
              // if(affiliateCode!== result.booking.affiliateCode) queryStringDiffersFromAmendedBooking = true
              const newState = {
                isLoaded: true,
                manageBookingResult: result,
                ajaxSpinnerActive: false,
                loadingFindBooking: false,
                changeFromBookingGuid: result.booking.guid,
                queryStringDiffersFromAmendedBooking: queryStringDiffersFromAmendedBooking,
              }

              // if the querystring is empty then update state with the data from the managed booking
              if (!this.state.hasQueryParameters) {
                newState.arrivalDate = result.booking.arrivalDate
                newState.arrivalTime = result.booking.arrivalTime
                newState.departureDate = result.booking.departureDate
                newState.departureTime = result.booking.departureTime
                newState.voucher = result.booking.promotionCode
                newState.affiliateCode = result.booking.affiliateCode
              }
              this.findUpsaleForBooking(result.booking.guid)
              this.setState(newState)
              return true // tell caller that this was a success
            })
            .catch((error) => {
              // console.log(JSON.stringify(error))
              // if (error.response && error.response.data.message && error.response.data.message)
              //   alert(error.response.data.message)
              // error is handled by findBookingError in state
              this.props.history.replace({
                pathname: path.AMMEND_SEARCH(),
                search: this.props.location.search,
              })
              this.genericModalOpen(
                config.get("textKeys.dialog.searchError") ||
                  "<h3>Fejl ved opslag på email og reference</h3><p>Vi kan ikke finde den angivne kombination af email og bookingnummer i systemet, kontroller at du har skrevet begge værdier korrekt</p><p>Prøv igen</p>",
              )
              this.setState({
                isLoaded: true,
                ajaxSpinnerActive: false,
                findBookingError: error,
                loadingFindBooking: false,
              })
            })
        },
      )
    }
  }

  getBookingByGuid = (bookingGuid, callback) => {
    if (!this.state.loadGetBookingByGuid) {
      this.setState(
        {
          loadGetBookingByGuid: true,
          loadGetBookingByGuidError: undefined,
        },
        () => {
          axios
            .get(endpoint.FIND_BOOKING_BY_GUID(bookingGuid))
            .then((res) => res.data)
            .then((result) => {
              this.setState(
                {
                  loadGetBookingByGuid: false,
                  manageBookingResult: result,
                },
                () => callback(),
              )

              return true // tell caller that this was a success
            })
            .catch((error) => {
              this.axiosErrorHandler(error, {
                ajaxSpinnerActive: false,
                loadGetBookingByGuid: false,
                loadGetBookingByGuidError: error,
              })
            })
        },
      )
    }
  }

  cancelBooking = (bookingGuid, callback) => {
    if (!this.state.loadCancelBooking) {
      this.setState(
        {
          ajaxSpinnerActive: true,
          loadCancelBooking: true,
          loadCancelBookingError: undefined,
        },
        () => {
          axios
            .post(endpoint.CANCELLATION(bookingGuid))
            .then(() => {
              this.getBookingByGuid(bookingGuid, () => {
                this.setState({
                  isLoaded: true,
                  ajaxSpinnerActive: false,
                  loadCancelBooking: false,
                })
              })
              return true // tell caller that this was a success
            })
            .then(() => callback())
            .catch((error) => {
              this.axiosErrorHandler(error, {
                ajaxSpinnerActive: false,
                loadCancelBooking: false,
                loadCancelBookingError: error,
              })
            })
        },
      )
    }
  }

  modifyBookingInformation = (information, callback = null) => {
    if (!this.state.loadingModifyBookingInformation) {
      const { booking } = this.state.manageBookingResult
      this.setState(
        {
          ajaxSpinnerActive: true,
          loadingModifyBookingInformation: true,
          loadingModifyBookingInformationError: undefined,
        },
        () => {
          const data = {
            arrivalDate: `${booking.arrivalDate} ${booking.arrivalTime}`,
            departureDate: `${booking.departureDate} ${booking.departureTime}`,
            ...information,
          }
          axios
            .post(endpoint.MODIFY_BOOKING_INFORMATION(this.state.manageBookingResult.booking.guid), data)
            .then((res) => res.data)
            .then((result) => {
              this.setState({
                isLoaded: true,
                manageBookingResult: result,
                ajaxSpinnerActive: false,
                loadingModifyBookingInformation: false,
              })
              if (callback) {
                callback()
              }
              return true // tell caller that this was a success
            })
            .catch((error) => {
              this.axiosErrorHandler(error, {
                ajaxSpinnerActive: false,
                loadingModifyBookingInformation: false,
                loadingModifyBookingInformationError: error,
              })
            })
        },
      )
    }
  }

  handleEmailOfferUpgrade = (bookingGuid) => {
    if (!this.state.emailUpgradeInProcess) {
      this.setState(
        {
          emailUpgradeInProcess: true,
          emailUpgradeGuid: bookingGuid,
          loadingHandleEmailOfferUpgradeError: undefined,
        },
        () => {
          storageHelper.setToSessionStorage("emailUpgradeGuid", bookingGuid)
          axios
            .get(endpoint.EMAIL_UPGRADE_BOOKING(bookingGuid))
            .then((res) => res.data)
            .then((result) => {
              if (!result.error) {
                this.setState(
                  {
                    emailUpgradeInProcess: false,
                    loadingHandleEmailOfferUpgrade: false,
                  },
                  () => {
                    this.props.history.push({
                      pathname: path.CHECKOUT(),
                      search: this.createQueryStrings(result),
                    })
                  },
                )
              } else {
                console.log(result.error)
              }
            })
            .catch((error) => {
              this.axiosErrorHandler(
                error,
                {
                  // ajaxSpinnerActive: false,
                  emailUpgradeInProcess: false,
                  loadingHandleEmailOfferUpgradeError: error,
                },
                {
                  noResponse: () =>
                    this.genericModalOpen(
                      config.get("textKeys.dialog.linkError") ||
                        `<h3>Fejl</h3><p>Der er en fejl i linket, hvis du har klippe klistret det ind så prøv igen</p>`,
                    ),
                  methodNotAllowed: () =>
                    this.genericModalOpen(
                      config.get("textKeys.dialog.upgradeError") ||
                        `<h3>Fejl</h3><p>Din booking kan ikke opgraderes, enten er tidsfristen udløbet, ellers også er der udsolgt</p>`,
                    ),
                },
              )
            })
        },
      )
    }
  }

  handleReservation = (id, item, callback, isAmendment = false) => {
    var hasChangeFromBooking = this.state.changeFromBooking ? true : false
    var hasLoggedInAccountDetails = this.state.userAccountDetails ? true : false
    var hasChangeFromBookingLoggedInHistory = false
    var hasAccountDetails = false
    var hasAccountHistory = false
    if (hasChangeFromBooking) {
      hasChangeFromBookingLoggedInHistory = this.state.changeFromBooking.booking.membershipNumber ? true : false
    }
    if (hasLoggedInAccountDetails) {
      hasAccountHistory = this.state.userAccountDetails.CustomerNumber ? true : false
    }
    let useMemberPricing =
      !item?.result?.showOriginalPrice &&
      item?.result?.showMemberPrice &&
      (hasAccountDetails || hasAccountHistory || hasChangeFromBookingLoggedInHistory)
        ? true
        : false

    if (!this.state.loadingHandleReservation) {
      // FOCUS
      // TODO check if context booking and use endpoint CHANGE_UPGRADE_BOOKING
      if (this.state.changeFromBookingGuid) {
        console.debug("handleReservation:" + endpoint.CHANGE_UPGRADE_BOOKING(this.state.changeFromBookingGuid) + ", id=" + id)
        const data = {
          arrivalDate: this.state.arrivalDate,
          arrivalTime: this.state.arrivalTime,
          departureDate: this.state.departureDate,
          departureTime: this.state.departureTime,
          productId: id,
          promotionCode: this.state.changeFromBooking?.booking?.promotionCode || "",
          affiliateCode: this.state.affiliateCode,
          // isAmendment: isAmendment,
          membershipId: hasAccountHistory
            ? this.state.changeFromBooking?.booking?.memberShipNumber
            : hasAccountDetails
              ? this.state.userAccountDetails?.CustomerNumber
              : "",
          useMemberPricing: useMemberPricing,
          validatePromoCodeWithAmendmentDates: !this.state.changeFromBooking?.booking?.promotionCode, // validate if promoCode comes from somewhere other than your previous booking
          thirdPartyPromoLabel: item?.result?.thirdPartyPromoLabel || "",
        }
        //membership id / pricing is checked first on the changed booking. If the previous booking wasnt logged in, then we check if you're actually logged in.
        this.setState(
          {
            ajaxSpinnerActive: true,
            loadingHandleReservation: true,
            loadingHandleReservationError: undefined,
          },
          () => {
            axios
              .put(endpoint.CHANGE_UPGRADE_BOOKING(this.state.changeFromBookingGuid), data)
              .then((result) => result.data)
              .then((result) => {
                if (result.message) {
                  console.debug(result.message)
                }

                if (result.booking) {
                  this.saveGuidToSessionStorage(result)
                  // TODO evaluate if we need extras
                  this.findExtrasForBooking(id, this.getArrivalData(), this.getDepartureData(), result.booking.guid, this.state.voucher)
                  this.setState(
                    {
                      bookingUpsale: undefined,
                      bookingResult: result,
                      loadingHandleReservation: false,
                    },
                    () => {
                      const query = {
                        ad: this.state.arrivalDate,
                        at: this.state.arrivalTime,
                        dd: this.state.departureDate,
                        dt: this.state.departureTime,
                        voucher: this.state.voucher,
                        affiliate: this.state.affiliateCode,
                        bguid: this.state.bookingResult.booking.guid,
                        cfguid: this.state.changeFromBookingGuid,
                        parkingProductId: id,
                        promotionCode: this.state.bookingResult.booking.bookingHistory.originalBooking.promotionCode,
                      }
                      if (this.state.ammendmentEmail) query.email = this.state.ammendmentEmail
                      if (this.state.ammendmentReference) query.reference = this.state.ammendmentReference

                      if (
                        result.activeBookingExtraProducts &&
                        result.activeBookingExtraProducts.find((product) => product.showBookingPage === false)
                      ) {
                        // booking already has carwash go directly to financial page
                        this.props.history.push({
                          pathname: path.CHECKOUT(),
                          search: this.createQueryStrings(query),
                        })
                      } else {
                        // JIRA: https://cph-airport.atlassian.net/browse/PAR-288
                        // Advam fails on Carwash change on booking amandment, so disabled until further notice
                        if (isAmendment) {
                          this.props.history.push({
                            pathname: path.AMMEND_CHECKOUT(),
                            search: this.createQueryStrings(query),
                          })
                        } else if (!isAmendment) {
                          this.props.history.push({
                            pathname: path.CHECKOUT(),
                            search: this.createQueryStrings(query),
                          })
                        }
                        // this.props.history.push({
                        //   pathname: path.EXTRA_SERVICES(),
                        //   search: this.createQueryStrings(query)
                        // })
                      }
                      if (callback) {
                        callback()
                        // console.log('calling back ' + callback);
                      }
                    },
                  )
                }
              })
              .catch((error) => {
                this.axiosErrorHandler(error, {
                  ajaxSpinnerActive: false,
                  loadingHandleReservation: false,
                  loadingHandleReservationError: error,
                })
              })
          },
        )
      } else {
        console.debug("handleReservation:" + endpoint.ADD_RESERVATION() + ", id=" + id)
        this.handleReservationInternal(id, item, callback)
      }
    }
  }

  handleReservationInternal = (productId, item, callback) => {
    const data = {
      arrivalDate: this.getArrivalData(),
      departureDate: this.getDepartureData(),
      productId: productId,
      promotionCode: this.state.voucher,
      affiliateCode: this.state.affiliateCode,
      usePromoCodePrice: item?.result?.showOriginalPrice || false,
      thirdPartyPromoLabel: item?.result?.thirdPartyPromoLabel || "",
      result: item?.result || null,
    }
    this.setState(
      {
        ajaxSpinnerActive: true,
        loadingHandleReservation: true,
        loadingHandleReservationError: undefined,
      },
      () => {
        axios
          .post(endpoint.ADD_RESERVATION(), data)
          .then((result) => result.data)
          .then((result) => {
            if (result.message) {
              console.debug(result.message)
            }
            if (result.booking) {
              this.saveGuidToSessionStorage(result)
              // PAR-2070 - moved history handling to findExtras function, to make the skipping of step 2 more smooth
              const query = {
                ad: this.state.arrivalDate,
                at: this.state.arrivalTime,
                dd: this.state.departureDate,
                dt: this.state.departureTime,
                voucher: this.state.voucher,
                affiliate: this.state.affiliateCode,
                bguid: result.booking.guid,
                cfguid: this.state.changeFromBookingGuid,
                parkingProductId: productId,
              }
              this.findExtrasForBooking(
                productId,
                this.getArrivalData(),
                this.getDepartureData(),
                result.booking.guid,
                this.state.voucher,
                true,
                this.createQueryStrings(query),
              )
              this.findUpsaleForBooking(result.booking.guid)
              this.setState({
                bookingUpsale: undefined,
                bookingResult: result,
                ajaxSpinnerActive: false,
                loadingHandleReservation: false,
              })
            }
            if (callback) {
              callback()
            }
          })
          .catch((error) => {
            this.axiosErrorHandler(error, {
              ajaxSpinnerActive: false,
              loadingHandleReservation: false,
              loadingHandleReservationError: error,
            })
          })
      },
    )
  }

  handleBookingExtension = (newDeparture, callback) => {
    var hasChangeFromBooking = this.state.changeFromBooking ? true : false
    var hasLoggedInAccountDetails = this.state.userAccountDetails ? true : false
    var hasChangeFromBookingLoggedInHistory = false
    var hasAccountDetails = false
    var hasAccountHistory = false

    if (hasChangeFromBooking) {
      hasChangeFromBookingLoggedInHistory = this.state.changeFromBooking.booking.membershipNumber ? true : false
    }

    if (hasLoggedInAccountDetails) {
      hasAccountHistory = this.state.userAccountDetails.CustomerNumber ? true : false
    }

    if (!this.state.loadingHandleReservation) {
      // FOCUS
      // TODO check if context booking and use endpoint CHANGE_UPGRADE_BOOKING
      if (this.state.changeFromBookingGuid) {
        console.debug(
          "handleBookingExtension:" +
            endpoint.EXECUTE_BOOKING_EXTENSION_BY_GUID(this.state.bookingExtension.booking.guid) +
            "?newDeparture=" +
            newDeparture,
        )
        const data = {
          newDeparture: newDeparture,
        }
        //membership id / pricing is checked first on the changed booking. If the previous booking wasnt logged in, then we check if you're actually logged in.
        this.setState(
          {
            ajaxSpinnerActive: true,
            loadingHandleReservation: true,
            loadingHandleReservationError: undefined,
          },
          () => {
            axios
              .get(endpoint.EXECUTE_BOOKING_EXTENSION_BY_GUID(this.state.bookingExtension.booking.guid) + "?newDeparture=" + data.newDeparture)
              .then((result) => result.data)
              .then((result) => {
                if (result.message) {
                  console.debug(result.message)
                }

                if (result.booking) {
                  this.saveGuidToSessionStorage(result)
                  // TODO evaluate if we need extras
                  this.setState(
                    {
                      bookingUpsale: undefined,
                      bookingResult: result,
                      loadingHandleReservation: false,
                      ajaxSpinnerActive: false,
                    },
                    () => {
                      const query = {
                        dd: this.state.departureDate,
                        dt: this.state.departureTime,
                        bguid: this.state.bookingExtension.booking.guid,
                        cfguid: this.state.changeFromBookingGuid,
                        extensionId: this.state.bookingExtension?.parkingExtension?.extensionId,
                      }
                      if (this.state.ammendmentEmail) query.email = this.state.bookingExtension.booking.email
                      if (this.state.ammendmentReference) query.reference = this.state.bookingExtension.booking.reference

                      // JIRA: https://cph-airport.atlassian.net/browse/PAR-288
                      // Advam fails on Carwash change on booking amandment, so disabled until further notice
                      if (this.state.bookingExtension) {
                        this.props.history.push({
                          pathname: path.EXTEND_CHECKOUT(),
                          search: this.createQueryStrings(query),
                        })
                      }

                      // this.props.history.push({
                      //   pathname: path.EXTRA_SERVICES(),
                      //   search: this.createQueryStrings(query)
                      // })
                      if (callback) {
                        callback()
                        // console.log('calling back ' + callback);
                      }
                    },
                  )
                }
              })
              .catch((error) => {
                this.axiosErrorHandler(error, {
                  ajaxSpinnerActive: false,
                  loadingHandleReservation: false,
                  loadingHandleReservationError: error,
                })
              })
          },
        )
      } else {
        this.handleReservationInternal(callback)
      }
    }
  }

  findUpsaleForBooking = (bookingGuid) => {
    let allowedUpsaleCarparks = ""
    if (this.props.content.allowedUpsaleCarparks) allowedUpsaleCarparks = this.props.content.allowedUpsaleCarparks
    if (!this.state.loadingFindUpsaleForBooking) {
      this.setState(
        {
          ajaxSpinnerActive: true,
          loadingFindUpsaleForBooking: true,
          loadingFindUpsaleForBookingError: undefined,
        },
        () => {
          axios
            .get(endpoint.FIND_BOOKING_UPSALE_BY_GUID(bookingGuid) + "?allowedUpsaleCarparks=" + encodeURIComponent(allowedUpsaleCarparks))
            .then((res) => res.data)
            .then((result) => {
              this.setState({
                bookingUpsale: result,
                ajaxSpinnerActive: false,
                loadingFindUpsaleForBooking: false,
              })
              return true // tell caller that this was a success
            })
            .catch((error) => {
              const text = this.axiosErrorHandler(error, {
                bookingUpsale: undefined,
                ajaxSpinnerActive: false,
                loadingFindUpsaleForBooking: false,
                loadingFindUpsaleForBookingError: error,
              })
              if (text) this.trackError(text, error, "upsale")
            })
        },
      )
    }
  }

  executeUpsaleForBooking = (bookingGuid, upsaleProductId, previousProductName, isAmendment = false) => {
    if (!this.state.loadingExecuteUpsaleForBooking) {
      this.setState(
        {
          ajaxSpinnerActive: true,
          loadingExecuteUpsaleForBooking: true,
          loadingExecuteUpsaleForBookingError: undefined,
        },
        () => {
          if (!isAmendment) {
            axios
              .post(
                endpoint.EXECUTE_BOOKING_UPSALE_BY_GUID(bookingGuid) +
                  "?upsaleProductId=" +
                  encodeURIComponent(upsaleProductId) +
                  "&previousProductName=" +
                  encodeURIComponent(previousProductName),
              )
              .then((res) => res.data)
              .then((result) => {
                if (result.booking) {
                  this.setState(
                    {
                      bookingResult: result,
                      ajaxSpinnerActive: false,
                      loadingAddExtraToBooking: false,
                      isUpsold: true,
                      // isAmendment: isAmendment
                    },
                    () => {
                      const query = {
                        ad: this.state.arrivalDate,
                        at: this.state.arrivalTime,
                        dd: this.state.departureDate,
                        dt: this.state.departureTime,
                        voucher: this.state.voucher,
                        affiliate: this.state.affiliateCode,
                        bguid: this.state.bookingResult.booking.guid,
                        cfguid: this.state.changeFromBookingGuid,
                        parkingProductId: upsaleProductId,
                        isUpsold: true,
                      }
                      if (this.state.ammendmentEmail) query.email = this.state.ammendmentEmail
                      if (this.state.ammendmentReference) query.reference = this.state.ammendmentReference

                      //set cookie with old product id and name, upsale product id and name
                      if (this.state.upsaleTrackingData) {
                        cookieHelper.setCookie("upsaleTrackingData", this.state.upsaleTrackingData)
                      }

                      // JIRA: https://cph-airport.atlassian.net/browse/PAR-288
                      // Advam fails on Carwah change on booking amandment, so disabled until further notice
                      if (isAmendment) {
                        //need to make this properly hit the amend checkout page.
                        this.props.history.replace({
                          pathname: path.AMMEND_CHECKOUT(),
                          search: this.createQueryStrings(query),
                        })
                      } else if (!isAmendment) {
                        this.props.history.replace({
                          pathname: path.CHECKOUT(),
                          search: this.createQueryStrings(query),
                        })
                      }
                      // this.props.history.push({
                      //   pathname: path.EXTRA_SERVICES(),
                      //   search: this.createQueryStrings(query)
                      // })
                    },
                  )
                }
                return true // tell caller that this was a success
              })
              .catch((error) => {
                const text = this.axiosErrorHandler(error, {
                  ajaxSpinnerActive: false,
                  loadingExecuteUpsaleForBooking: false,
                  loadingExecuteUpsaleForBookingError: error,
                })
                if (text) this.trackError(text, error, "upsale")
              })
          } else if (isAmendment) {
            //set cookie with old product id and name, upsale product id and name
            if (this.state.upsaleTrackingData) {
              cookieHelper.setCookie("upsaleTrackingData", this.state.upsaleTrackingData)
            }
            this.handleReservation(this.state.bookingUpsale.result.product, "", null, isAmendment)
          }
        },
      )
    }
  }

  findExtrasForBooking = (productId, arrival, departure, bookingGuid, voucher, handleHistory = false, query = "") => {
    if (!this.state.loadingFindExtrasForBooking) {
      this.setState(
        {
          ajaxSpinnerActive: true,
          loadingFindExtrasForBooking: true,
          loadingFindExtrasForBookingError: undefined,
        },
        () => {
          axios
            .get(
              endpoint.FIND_EXTRAS_WITH_CONFIG(bookingGuid) +
                "?productId=" +
                encodeURIComponent(productId) +
                "&arrival=" +
                encodeURIComponent(arrival) +
                "&departure=" +
                encodeURIComponent(departure) +
                "&promotionCode=" +
                encodeURIComponent(voucher),
            )
            .then((res) => res.data)
            .then((result) => {
              if (handleHistory === true && query !== "") {
                const textKeys = config.get("textKeys")
                let showStep2 = textKeys.extraServices.showExtraServicesStep
                if (showStep2) {
                  // if showStep2, enforce another rule
                  const extras = result.extras
                  showStep2 = extras.length > 0 || extras.filter((be) => !be.showBookingPage).length > 0
                }
                this.props.history.push({
                  pathname: showStep2 ? path.EXTRA_SERVICES() : path.CHECKOUT(),
                  search: query,
                })
              }
              let bookingExtrasConfiguration = result.configuration
              const environment = config.get("environment")
              if (environment && environment !== "") {
                if (bookingExtrasConfiguration.extraServices) {
                  bookingExtrasConfiguration.extraServices = bookingExtrasConfiguration.extraServices.filter(
                    (es) => !es.environment || es.environment === environment,
                  )
                }
              }

              this.setState({
                bookingExtras: result.extras,
                bookingExtrasConfiguration,
                ajaxSpinnerActive: false,
                loadingFindExtrasForBooking: false,
              })
              return true // tell caller that this was a success
            })
            .catch((error) => {
              const text = this.axiosErrorHandler(error, {
                ajaxSpinnerActive: false,
                loadingFindExtrasForBooking: false,
                loadingFindExtrasForBookingError: error,
              })
              if (text) this.trackError(text, error, "search")
            })
        },
      )
    }
  }

  closePaymentModal = () => {
    this.setState({
      paymentData: undefined,
      paymentModalActive: false,
      ajaxSpinnerActive: false,
      ajaxSpinnerTransparent: undefined,
      loadingInitiatePayment: false,
    })
  }

  addExtraToBooking = (extraProduct, extraOfferLineItem, callback) => {
    const textKeys = config.get("textKeys.dialog") || {}
    if (!this.state.loadingAddExtraToBooking) {
      const hasSelectedproduct =
        this.state.bookingResult &&
        this.state.bookingResult.activeBookingExtraProducts &&
        this.state.bookingResult.activeBookingExtraProducts.find((e) => e.product.id === extraProduct.id)

      console.debug(`extraProdutId: ${extraProduct.id}, extraOfferLineId:${extraOfferLineItem.id}`)

      const addProductOperation = () => {
        const data = {
          arrivalDate: this.getArrivalData(),
          departureDate: this.getDepartureData(),
          offerLineId: extraOfferLineItem.id,
          extraId: extraProduct.id,
        }

        axios
          .post(endpoint.ADD_EXTRAS(this.state.bookingResult.booking.guid), data)
          .then((result) => result.data)
          .then((result) => {
            if (result.message) {
              console.debug(result.message)
            }
            if (result.booking) {
              this.setState(
                {
                  bookingResult: result,
                  ajaxSpinnerActive: false,
                  loadingAddExtraToBooking: false,
                },
                callback,
              )
            }
          })
          .catch((error) => {
            this.axiosErrorHandler(
              error,
              {
                ajaxSpinnerActive: false,
                loadingAddExtraToBooking: false,
                loadingAddExtraToBookingError: error,
              },
              {
                notFound: () => {
                  this.genericModalOpen(
                    textKeys.invalidBookingForExtra || `<h3>Fejl</h3><p>Denne booking er i en tilstand hvor tillægsprodukter ikke kan ændres</p>`,
                  )
                },
              },
            )
          })
      }

      this.setState(
        {
          ajaxSpinnerActive: true,
          loadingAddExtraToBooking: true,
          loadingAddExtraToBookingError: undefined,
        },
        () => {
          if (hasSelectedproduct) {
            this.removeExtraFromBooking(extraProduct, addProductOperation, true)
          } else addProductOperation()
        },
      )
    }
  }

  removeExtraFromBooking = (extraProduct, callback, keepSpinner = false) => {
    if (!this.state.loadRemoveExtraFromBooking) {
      this.setState(
        {
          ajaxSpinnerActive: true,
          loadRemoveExtraFromBooking: true,
          loadRemoveExtraFromBookingError: undefined,
        },
        () => {
          axios
            .delete(endpoint.REMOVE_EXTRAS(this.state.bookingResult.booking.guid) + "?extraId=" + extraProduct.id)
            .then((result) => result.data)
            .then((result) => {
              if (result.message) {
                console.debug(result.message)
              }
              if (result.booking) {
                this.setState(
                  {
                    isLoaded: true,
                    bookingResult: result,
                    ajaxSpinnerActive: keepSpinner,
                    loadRemoveExtraFromBooking: false,
                  },
                  callback,
                )
              }
            })
            .catch((error) => {
              this.axiosErrorHandler(error, {
                ajaxSpinnerActive: false,
                loadRemoveExtraFromBooking: false,
                loadRemoveExtraFromBookingError: error,
              })
            })
        },
      )
    }
  }

  removeExtraOfferlineFromBooking = (extraProductId, extraItemId, callback, keepSpinner = false) => {
    if (!this.state.loadRemoveExtraOfferLineFromBooking) {
      this.setState(
        {
          ajaxSpinnerActive: true,
          loadRemoveExtraOfferLineFromBooking: true,
          loadRemoveExtraOfferLineFromBookingError: undefined,
        },
        () => {
          axios
            .delete(
              endpoint.REMOVE_EXTRAS_OFFERLINE(this.state.bookingResult.booking.guid) + "?extraId=" + extraProductId + "&extraItemId=" + extraItemId,
            )
            .then((result) => result.data)
            .then((result) => {
              if (result.message) {
                console.debug(result.message)
              }
              if (result.booking) {
                this.setState(
                  {
                    isLoaded: true,
                    bookingResult: result,
                    ajaxSpinnerActive: keepSpinner,
                    loadRemoveExtraOfferLineFromBooking: false,
                  },
                  callback,
                )
              }
            })
            .catch((error) => {
              this.axiosErrorHandler(error, {
                ajaxSpinnerActive: false,
                loadRemoveExtraOfferLineFromBooking: false,
                loadRemoveExtraOfferLineFromBookingError: error,
              })
            })
        },
      )
    }
  }

  prepareForPayment = (bookingGuid, extensionId) => {
    if (!this.state.loadingPrepareForPayment) {
      this.setState(
        {
          ajaxSpinnerActive: true,
          loadingPrepareForPayment: true,
          loadingPrepareForPaymentError: undefined,
        },
        () => {
          const { billingAddress, vechicleInformation, flightInformation, consentInformation, bookingResult } = this.state
          const agreements = { ...consentInformation }
          const customFieldValues = bookingResult?.booking?.customFieldValues || {}
          // backend doesn't have a field for terms_and_condition, so remove that
          if (Object.hasOwn(agreements, "terms_and_condition")) {
            delete agreements["terms_and_condition"]
          }
          const consents = this.state.consentContent.items.filter((consent) => consent.consentId != "terms_and_condition")
          const permissions = consents.map((item) => {
            return {
              permissionId: item.consentId || "",
              permissionVersion: item.consentVersion || "",
              permissionLanguage: "da",
              permissionGiven: agreements[item.consentId] || false,
            }
          })
          const data = {
            ...billingAddress,
            ...vechicleInformation,
            ...flightInformation,
            agreements,
            permissions,
            customFieldValues,
            membershipID: "",
          }
          axios
            .put(endpoint.PREPARE_PAYMENT(bookingGuid, extensionId), data)
            .then((result) => result.data)
            .then((result) =>
              this.setState(
                {
                  bookingResult: result,
                  loadingPrepareForPayment: false,
                },
                () => {
                  this.initiatePayment(bookingGuid, extensionId)
                },
              ),
            )
            .catch((error) => {
              const text = this.axiosErrorHandler(error, {
                ajaxSpinnerActive: false,
                loadingPrepareForPayment: false,
                loadingPrepareForPaymentError: error,
              })
              if (text) this.trackError(text, error, "payment")
            })
        },
      )
    }
  }

  prepareForPaymentMobilePay = (bookingGuid, extensionId) => {
    if (!this.state.loadingPrepareForPayment) {
      this.setState(
        {
          ajaxSpinnerActive: true,
          loadingPrepareForPayment: true,
          loadingPrepareForPaymentError: undefined,
        },
        () => {
          const { billingAddress, vechicleInformation, flightInformation, consentInformation, bookingResult } = this.state
          const agreements = { ...consentInformation }
          const customFieldValues = bookingResult?.booking?.customFieldValues || {}
          // backend doesn't have a field for terms_and_condition, so remove that
          if (Object.hasOwn(agreements, "terms_and_condition")) {
            delete agreements["terms_and_condition"]
          }
          const consents = this.state.consentContent.items.filter((consent) => consent.consentId != "terms_and_condition")
          const permissions = consents.map((item) => {
            return {
              permissionId: item.consentId || "",
              permissionVersion: item.consentVersion || "",
              permissionLanguage: "da",
              permissionGiven: agreements[item.consentId] || false,
            }
          })
          const data = {
            ...billingAddress,
            ...vechicleInformation,
            ...flightInformation,
            agreements,
            permissions,
            customFieldValues,
            membershipID: "",
          }
          axios
            .put(endpoint.PREPARE_PAYMENT(bookingGuid, extensionId), data)
            .then((result) => result.data)
            .then((result) =>
              this.setState(
                {
                  bookingResult: result,
                  loadingPrepareForPayment: false,
                },
                () => {
                  this.initiatePaymentMobilePay(bookingGuid, extensionId)
                },
              ),
            )
            .catch((error) => {
              const text = this.axiosErrorHandler(error, {
                ajaxSpinnerActive: false,
                loadingPrepareForPayment: false,
                loadingPrepareForPaymentError: error,
              })
              if (text) this.trackError(text, error, "payment")
            })
        },
      )
    }
  }

  initiatePaymentMobilePay = (bookingGuid, extensionId) => {
    const textKeys = config.get("textKeys.dialog") || {}
    let isExtension = extensionId > 0 ? true : false
    let isAmendment = !extensionId && this.state.bookingResult?.bookingHistory
    if (!this.state.loadingInitiatePayment) {
      this.setState(
        {
          loadingInitiatePayment: true,
          loadingInitiatePaymentError: undefined,
          ajaxSpinnerActive: true,
          //    ajaxSpinnerTransparent: true,
        },
        () => {
          axios
            .post(
              endpoint.INITIATE_PAYMENT_MP() +
                "?bookingGuid=" +
                encodeURIComponent(bookingGuid) +
                "&extensionId=" +
                encodeURIComponent(extensionId) +
                "&languageCode=" +
                endpoint.locale() +
                `${this.state.flightId ? `&flightId=${this.state.flightId}` : ""}`,
            )
            .then((result) => {
              if (result.status === 202) {
                this.setState(
                  {
                    ajaxSpinnerActive: false,
                    ajaxSpinnerTransparent: undefined,
                    loadingPayWithWallet: false,
                  },
                  () => {
                    this.props.history.push({
                      pathname: path.RECEIPT(),
                      search: `?bguid=${bookingGuid}&source=${isExtension ? "extension" : isAmendment ? "amend" : "standard"}`,
                    })
                  },
                )
                return
              }
              console.debug(result.data)
              return result.data
            })
            .then((result) => {
              new Wallet().open(result.walletSessionId)
              const trackingProps = {
                cookies: this.props.cookies,
                arrivalDate: this.state.arrivalDate,
                departureDate: this.state.departureDate,
              }
              if (this.state.consentInformation.privacyOptIn) {
                tracking.trackPermissionOptIn(trackingProps, "newsletter", "parking purchase")
              }
              if (this.state.consentInformation.emailOptIn) {
                tracking.trackPermissionOptIn(trackingProps, "related products", "parking purchase")
              }
            })
            .catch((error) => {
              const text = this.axiosErrorHandler(
                error,
                {
                  ajaxSpinnerActive: false,
                  ajaxSpinnerTransparent: undefined,
                  loadingInitiatePayment: false,
                  loadingInitiatePaymentError: error,
                },
                {
                  badRequest: (s) => {
                    const data = JSON.parse(s)
                    if (data.errorMessage === "PAYMENT_EXISTS") {
                      this.genericModalOpen(
                        textKeys.paymentInProgress ||
                          `<h3>Ordren er under behandling</h3><p>Der er allerede en betaling i gang for denne ordre</p><p>Du vil modtage en ordrebekræftelse på email indenfor få minutter</p>`,
                        () => {
                          this.props.history.push({
                            pathname: path.RECEIPT(),
                            search: `?bguid=${bookingGuid}`,
                          })
                        },
                      )
                    }
                  },
                },
              )
              if (text) this.trackError(text, error, "payment")
            })
        },
      )
    }
  }

  initiatePayment = (bookingGuid, extensionId) => {
    const textKeys = config.get("textKeys.dialog") || {}
    let isExtension = extensionId > 0 ? true : false
    let isAmendment = !extensionId && this.state.bookingResult?.bookingHistory
    if (!this.state.loadingInitiatePayment) {
      this.setState(
        {
          loadingInitiatePayment: true,
          loadingInitiatePaymentError: undefined,
          ajaxSpinnerActive: true,
          //    ajaxSpinnerTransparent: true,
        },
        () => {
          axios
            .post(
              endpoint.INITIATE_PAYMENT_V2() +
                "?bookingGuid=" +
                encodeURIComponent(bookingGuid) +
                "&extensionId=" +
                encodeURIComponent(extensionId) +
                "&languageCode=" +
                endpoint.locale() +
                "&affiliateCode=" +
                this.state.affiliateCode +
                `${this.state.flightId ? `&flightId=${this.state.flightId}` : ""}`,
            )
            .then((result) => {
              if (result.status === 202) {
                this.getBookingByGuid(bookingGuid, () => {
                  // force reciept reload after no-pay handling in backend
                  this.setState(
                    {
                      ajaxSpinnerActive: false,
                      ajaxSpinnerTransparent: undefined,
                      loadingPayWithWallet: false,
                      bookingResult: this.state.manageBookingResult,
                    },
                    () => {
                      this.props.history.push({
                        pathname: path.RECEIPT(),
                        search: `?bguid=${bookingGuid}&source=${isExtension ? "extension" : isAmendment ? "amend" : "standard"}`,
                      })
                    },
                  )
                  return
                })
              }
              return result.data
            })
            .then((result) => {
              this.setState(
                {
                  paymentData: result,
                  paymentModalActive: true,
                  ajaxSpinnerActive: false,
                  ajaxSpinnerTransparent: undefined,
                  loadingInitiatePayment: false,
                },
                () => {
                  // there is only paymentdata in state if the result is not a no-pay scenario
                  if (this.state.paymentData) {
                    // remove this to revert back to payment modal
                    tracking.trackBamboraShow(this.props, this.state.bookingResult)
                    new RedirectCheckout(this.state.paymentData.verificationToken)
                  }
                },
              )
              const trackingProps = {
                cookies: this.props.cookies,
                arrivalDate: this.state.arrivalDate,
                departureDate: this.state.departureDate,
              }
              if (this.state.consentInformation.privacyOptIn) {
                tracking.trackPermissionOptIn(trackingProps, "newsletter", "parking purchase")
              }
              if (this.state.consentInformation.emailOptIn) {
                tracking.trackPermissionOptIn(trackingProps, "related products", "parking purchase")
              }
            })
            .catch((error) => {
              const text = this.axiosErrorHandler(
                error,
                {
                  ajaxSpinnerActive: false,
                  ajaxSpinnerTransparent: undefined,
                  loadingInitiatePayment: false,
                  loadingInitiatePaymentError: error,
                },
                {
                  badRequest: (s) => {
                    const data = JSON.parse(s)
                    if (data.errorMessage === "PAYMENT_EXISTS") {
                      this.genericModalOpen(
                        textKeys.paymentInProgress ||
                          `<h3>Ordren er under behandling</h3><p>Der er allerede en betaling i gang for denne ordre</p><p>Du vil modtage en ordrebekræftelse på email indenfor få minutter</p>`,
                        () => {
                          this.props.history.push({
                            pathname: path.RECEIPT(),
                            search: `?bguid=${bookingGuid}`,
                          })
                        },
                      )
                    }
                  },
                },
              )
              if (text) this.trackError(text, error, "payment gateway")
            })
        },
      )
    }
  }

  clearBookingContext = (callback) => {
    this.setState(
      {
        changeFromBooking: undefined,
        manageBookingResult: undefined,
        bookingResult: undefined,
      },
      callback,
    )
  }

  getCart = (guid, callback = null) => {
    if (!guid) return
    if (!this.state.loadingGetCart) {
      this.setState(
        {
          loadingGetCart: true,
          loadingGetCartError: undefined,
        },
        () => {
          axios
            .get(endpoint.FIND_BOOKING() + "/" + guid)
            .then((res) => res.data)
            .then((res) => {
              if (res.booking.guid !== guid) {
                // server renewed the booking change the guid
                const query = QueryString.parse(this.props.location.search)
                query.bguid = res.booking.guid
                this.props.history.replace({
                  search: this.createQueryStrings(query),
                })
              }
              const { billingAddress, vechicleInformation, flightInformation } = this.state

              const newBillingAddress = {
                firstName: res.booking.firstName || (billingAddress && billingAddress.firstName) || "",
                lastName: res.booking.lastName || (billingAddress && billingAddress.lastName) || "",
                postcode: res.booking.postcode || (billingAddress && billingAddress.postcode) || "",
                town: res.booking.town || (billingAddress && billingAddress.town) || "",
                email: res.booking.email || (billingAddress && billingAddress.email) || "",
                mobilePhone: res.booking.mobilePhone || (billingAddress && billingAddress.mobilePhone) || "",
                countryId: res.booking.countryId || (billingAddress && billingAddress.countryId) || "293",
              }
              const newVechicleInformation = {
                vehicleColour: res.booking.vehicleColour || (vechicleInformation && vechicleInformation.vehicleColour) || "",
                vehicleMake: res.booking.vehicleMake || (vechicleInformation && vechicleInformation.vehicleMake) || "",
                vehicleModel: res.booking.vehicleModel || (vechicleInformation && vechicleInformation.vehicleModel) || "",
                vehicleRegistrationNumber:
                  res.booking.vehicleRegistrationNumber || (vechicleInformation && vechicleInformation.vehicleRegistrationNumber) || "",
              }
              const newFlightInformation = {
                inboundFlightDate: res.booking.arrivalDate || (flightInformation && flightInformation.arrivalDate) || "",
                outboundFlightDate: res.booking.departureDate || (flightInformation && flightInformation.departureDate) || "",
              }

              this.setState(
                {
                  billingAddress: newBillingAddress,
                  vechicleInformation: newVechicleInformation,
                  flightInformation: newFlightInformation,
                  bookingResult: res,
                  ajaxSpinnerActive: false,
                  loadingGetCart: false,
                  loadingGetCartError: undefined,
                },
                () => {
                  if (callback) callback(res)
                },
              )
            })
            .catch((error) => {
              this.axiosErrorHandler(error, {
                ajaxSpinnerActive: false,
                loadingGetCart: false,
                loadingGetCartError: error,
              })
            })
        },
      )
    }
  }

  loadChangeFromBooking = (guid, callback = null) => {
    if (!guid) return
    if (!this.state.loadingLoadChangeFromBooking) {
      this.setState(
        {
          loadingLoadChangeFromBooking: true,
          loadingLoadChangeFromBookingError: undefined,
        },
        () => {
          axios
            .get(endpoint.FIND_BOOKING() + "/" + guid)
            .then((res) => res.data)
            .then((res) => {
              const billingAddress = {
                firstName: res.booking.firstName || "",
                lastName: res.booking.lastName || "",
                postcode: res.booking.postcode || "",
                town: res.booking.town || "",
                email: res.booking.email || "",
                mobilePhone: res.booking.mobilePhone || "",
                countryId: res.booking.countryId || "293",
              }
              const vechicleInformation = {
                vehicleColour: res.booking.vehicleColour || "",
                vehicleMake: res.booking.vehicleMake || "",
                vehicleModel: res.booking.vehicleModel || "",
                vehicleRegistrationNumber: res.booking.vehicleRegistrationNumber || "",
              }
              const flightInformation = {
                inboundFlightDate: res.booking.arrivalDate,
                outboundFlightDate: res.booking.departureDate,
              }
              this.setState(
                {
                  billingAddress,
                  vechicleInformation,
                  flightInformation,
                  changeFromBooking: res,
                  changeFromBookingGuid: guid,
                  loadingLoadChangeFromBooking: false,
                },
                callback,
              )
            })
            .catch((error) => {
              this.axiosErrorHandler(error, {
                ajaxSpinnerActive: false,
                loadingLoadChangeFromBooking: false,
                loadingLoadChangeFromBookingError: error,
              })
            })
        },
      )
    }
  }

  validationMessageReplace(value, message) {
    return message?.replace("{value}", value)
  }

  setDataToState = (data) => {
    this.setState(data)
  }

  handleModalClose = () => {
    this.setState({ refundGuaranteeModalOpen: false })
  }

  scrollToElement = () => {
    var el = document.getElementsByClassName("js--scroll-anchor")[0]
    var headerOffset = document.getElementsByClassName("section-header__inner")[0].offsetHeight
    var elementPosition = el.getBoundingClientRect().top
    var offsetPosition = elementPosition - headerOffset

    window.scrollTo({
      top: offsetPosition,
      behavior: "smooth",
    })
  }

  render() {
    const { userAccountDetails, allProducts, arrivalDate, arrivalTime, departureDate, departureTime, voucher, affiliateCode } = this.state
    const textKeys = config.get("textKeys")

    const stepHeaderTextKeys = config.get("textKeys.progressIndicator") || {}
    const stepHeaderTextKeyLabels = config.get("textKeys.stepHeader") || {}

    const amendmentEditInfoTextKeys = config.get("textKeys.amendment.editInfo") || {}
    const amendmentManageTextKeys = config.get("textKeys.amendment.manage") || {}
    const amendmentUpgradeTextKeys = config.get("textKeys.amendment.upgrade") || {}

    const refundGuaranteeTextKeys = config.get("textKeys.refundGuarantee") || {}

    const extraServicesTextKeys = config.get("textKeys.extraServices") || {}

    const followFlightTextKeys = config.get("textKeys.followFlight") || {}
    const followFlightSignupModalTextKeys = config.get("textKeys.followFlightSignupModal") || {}

    let showExtraServicesStep = extraServicesTextKeys?.showExtraServicesStep ?? true
    if (showExtraServicesStep) {
      if (this.state.bookingExtras)
        showExtraServicesStep = this.state.bookingExtras.length > 0 || this.state.bookingExtras.filter((be) => !be.showBookingPage).length > 0
    }

    const isUpgrade =
      getQueryStringValue("isUpgrade") === "true" ??
      (this.state.emailUpgradeGuid && this.state.bookingResult && !!this.state.bookingResult?.modificationSummary)

    return (
      <React.Fragment>
        {/* state validation */}
        <Route
          path={path.HOME()}
          exact
          render={() => <Spinner isActive={this.state.ajaxSpinnerActive} isTransparent={this.state.ajaxSpinnerTransparent} />}
        />
        {/*<Route path={path.AMMEND_SEARCH()} render={() => <Spinner isActive={this.state.ajaxSpinnerActive} isTransparent={this.state.ajaxSpinnerTransparent} />} /> */}
        {/* most exact routes first then more generic*/}
        <Switch>
          {showExtraServicesStep ? (
            <Route
              path={path.EXTRA_SERVICES()}
              exact
              render={(props) => (
                <React.Fragment>
                  <Spinner isActive={this.state.ajaxSpinnerActive} isTransparent={this.state.ajaxSpinnerTransparent} />
                  <ProgressIndicator
                    step={2}
                    userAccountDetails={userAccountDetails}
                    setLoginState={this.setLoginState}
                    handleCurrentStep={this.handleCurrentStep}
                    handleLogOut={this.handleLogOut}
                    arrivalDate={arrivalDate}
                    arrivalTime={arrivalTime}
                    departureDate={departureDate}
                    departureTime={departureTime}
                    showExtraServicesStep={showExtraServicesStep}
                    {...this.props}
                    {...props}
                  />
                  <section className="checkout-basket-wrapper deck deck--blue">
                    <ParkingCheckoutBasket
                      {...this.state}
                      bookingResult={this.state.bookingResult}
                      priceFormatter={this.props.priceFormatter}
                      getExtraPrice={this.getExtraPrice}
                      parkingTimeModalToogle={this.parkingTimeModalToogle}
                      performParkingSearch={this.performParkingSearch}
                      removeExtraFromBooking={this.removeExtraFromBooking}
                      cookies={this.props.cookies}
                    />
                  </section>
                  <React.Fragment>
                    <SectionHeader
                      headline={stepHeaderTextKeys.step2 || "Ekstra services"}
                      buttonText={stepHeaderTextKeyLabels.step2nextLabel || "Fortsæt uden bilpleje"}
                      modifier_class="section-header--significant"
                      nextStepPath={{ path: path.CHECKOUT() }}
                      {...props}
                    />
                    <ParkingExtraServicesPodiumList
                      extraServiceModalSelectorToogle={this.extraServiceModalSelectorToogle}
                      extraServiceModalInfoToogle={this.extraServiceModalInfoToogle}
                      extraServicesDetailsModalToggle={this.extraServicesDetailsModalToggle}
                      extraServicesAcceptConditionsModalActivate={this.extraServicesAcceptConditionsModalActivate}
                      addExtraToBooking={this.addExtraToBooking}
                      removeExtraFromBooking={this.removeExtraFromBooking}
                      isSelected={this.props.isSelected}
                      bookingResult={this.state.bookingResult}
                      content={this.props.content}
                      track={true}
                      useNewDesign={config.get("textKeys.productPodium")?.useNewProductPodiumDesign ?? false}
                      {...this.state}
                      {...this.props}
                      {...props}
                    />
                  </React.Fragment>
                  {/* <ParkingExtraServices
                extraServiceModalSelectorToogle={this.extraServiceModalSelectorToogle}
                extraServiceModalInfoToogle={this.extraServiceModalInfoToogle}
                findExtrasForBooking={this.findExtrasForBooking}
                addExtraToBooking={this.addExtraToBooking}
                removeExtraFromBooking={this.removeExtraFromBooking}
                {...this.state}
                {...this.props}
                {...props}
              /> */}
                  {this.state.changeFromBookingGuid ? (
                    <FaqTop3
                      faqContent={config.get("faq.amendment")}
                      arrivalDate={arrivalDate}
                      arrivalTime={arrivalTime}
                      departureDate={departureDate}
                      departureTime={departureTime}
                      cookies={this.props.cookies}
                      step={3}
                    />
                  ) : (
                    <FaqTop3
                      faqContent={config.get("faq.extras")}
                      arrivalDate={arrivalDate}
                      arrivalTime={arrivalTime}
                      departureDate={departureDate}
                      departureTime={departureTime}
                      cookies={this.props.cookies}
                      step={3}
                    />
                  )}
                </React.Fragment>
              )}
            />
          ) : null}

          {/* this is the list of parkings */}
          <Route
            path={path.SEARCH()}
            exact
            render={(props) => (
              <React.Fragment>
                <ProgressIndicator
                  step={1}
                  userAccountDetails={userAccountDetails}
                  setLoginState={this.setLoginState}
                  handleCurrentStep={this.handleCurrentStep}
                  handleLogOut={this.handleLogOut}
                  arrivalDate={arrivalDate}
                  arrivalTime={arrivalTime}
                  departureDate={departureDate}
                  departureTime={departureTime}
                  showExtraServicesStep={showExtraServicesStep}
                  {...this.props}
                  {...props}
                />
                {/* <StepHeader
                    title={stepHeaderTextKeys.step1 || "Vælg plads"}
                    goBackPath={!this.state.changeFromBookingGuid ?
                      { path: path.HOME() }
                      :
                      {
                        path: path.AMMEND_SHOW_BOOKING(),
                        search: this.createQueryStrings({
                          email: this.state.ammendmentEmail,
                          reference: this.state.ammendmentReference
                        })
                      }
                    }
                    {...props}
                  /> */}
                {/* bookingstarter is now included */}
                <section className="parking-time-picker-wrapper deck deck--blue deck--front deck--padding-bottom">
                  <BookingStarter
                    wide={true}
                    flow={true}
                    modifiers={"parking-time-picker--blue parking-time-picker--flow"}
                    campaignCode={true}
                    slimVersion={true}
                    noHeader={true}
                    formClasses={null}
                    voucher={this.state.voucher}
                    searchData={{
                      ad: arrivalDate,
                      at: arrivalTime,
                      dd: departureDate,
                      dt: departureTime,
                      affiliateCode,
                    }}
                    textKeys={config.get("textKeys.bookingStarter") || {}}
                    {...this.props}
                    {...this.state}
                    {...props}
                    performParkingSearch={this.performParkingSearch}
                    performChangeBookingSearch={this.performChangeBookingSearch}
                    showDefaultDates={false}
                    disclaimer={undefined}
                    leadTimeInHours={this.props.content.leadTimeInHours || 1}
                  />
                </section>
                <StepHeader
                  title={stepHeaderTextKeys.step1 || "Vælg parkering"}
                  isParkingListView={true}
                  goBackPath={
                    !this.state.changeFromBookingGuid
                      ? { path: path.HOME() }
                      : {
                          path: path.AMMEND_SHOW_BOOKING(),
                          search: this.createQueryStrings({
                            email: this.state.ammendmentEmail,
                            reference: this.state.ammendmentReference,
                          }),
                        }
                  }
                  nextStepPath={{ path: showExtraServicesStep ? path.EXTRA_SERVICES() : path.CHECKOUT() }}
                  arrivalDate={arrivalDate}
                  arrivalTime={arrivalTime}
                  departureDate={departureDate}
                  departureTime={departureTime}
                  useNewDesign={config.get("textKeys.productPodium")?.useNewProductPodiumDesign ?? false}
                  deck={
                    config.get("textKeys.productPodium")?.useNewProductPodiumDesign
                      ? `deck deck--white deck--padding-top ${
                          config.get("textKeys.refundGuarantee")?.refundGuaranteeText ? "" : "deck--extra-padding-bottom"
                        }`
                      : "deck deck--white deck--padding-top deck--padding-bottom"
                  }
                  modifier={
                    config.get("textKeys.productPodium")?.useNewProductPodiumDesign && !config.get("textKeys.refundGuarantee")?.refundGuaranteeText
                      ? "header-spacer"
                      : ""
                  }
                  {...this.props}
                  {...props}
                />
                <RefundGuarantee
                  textKeys={config.get("textKeys.refundGuarantee")}
                  setDataToState={this.setDataToState}
                  modifier={"fit-content"}
                  useNewDesign={config.get("textKeys.productPodium")?.useNewProductPodiumDesign ?? false}
                />
                <ParkingProductHightlight
                  highlights={this.state.parkingHighlights}
                  setParkingDetailModalState={this.setParkingDetailModalState}
                  handleReservation={this.handleReservation}
                  gaList={this.state.parkingDetailsModalGaList}
                  gaListIndex={this.state.parkingDetailsModalGaListIndex}
                  useNewDesign={config.get("textKeys.productPodium")?.useNewProductPodiumDesign ?? false}
                  enableCarousel={config.get("textKeys.productPodium")?.enableProductPodiumCarousel ?? false}
                  uspLimit={config.get("textKeys.productPodium")?.productPodiumUspLimit ?? 3}
                  handleCloseMapModal={this.handleCloseMapModal}
                  handleOpenMapModal={this.handleOpenMapModal}
                  deck={"deck deck--white"}
                  wrapper={config.get("textKeys.productPodium")?.useNewProductPodiumDesign ? "w--normal" : "w--wider"}
                  {...this.props}
                  {...this.state}
                />
                <ParkingProductBrowser
                  showMapInitially={this.state.showMapInitially}
                  parkingList={
                    <ParkingList
                      isAmendment={false}
                      allProducts={allProducts}
                      performParkingSearch={this.performParkingSearch}
                      performChangeBookingSearch={this.performChangeBookingSearch}
                      arrivalDate={arrivalDate}
                      arrivalTime={arrivalTime}
                      departureDate={departureDate}
                      departureTime={departureTime}
                      voucher={voucher}
                      affiliateCode={affiliateCode}
                      getArrivalData={this.getArrivalData}
                      getDepartureData={this.getDepartureData}
                      handleReservation={this.handleReservation}
                      bookingResults={this.state.bookingResult}
                      removeBooking={this.removeBooking}
                      handleSorting={this.handleSorting}
                      changeFromBookingGuid={this.state.changeFromBookingGuid}
                      setParkingDetailModalState={this.setParkingDetailModalState}
                      useNewDesign={config.get("textKeys.productPodium")?.useNewProductPodiumDesign ?? false}
                      {...props}
                      {...this.props}
                      {...this.state}
                    />
                  }
                  parkingMap={
                    allProducts.length > 0 ? (
                      <Map
                        allProducts={allProducts}
                        handleReservation={this.handleReservation}
                        setParkingDetailModalState={this.setParkingDetailModalState}
                        gaList={this.state.parkingDetailsModalGaList}
                        gaListIndex={this.state.parkingDetailsModalGaListIndex}
                        {...this.props}
                        {...this.state}
                      />
                    ) : null
                  }
                  arrivalDate={arrivalDate}
                  arrivalTime={arrivalTime}
                  departureDate={departureDate}
                  departureTime={departureTime}
                  {...this.props}
                  {...this.state}
                />
                {this.state.changeFromBookingGuid ? (
                  <FaqTop3
                    faqContent={config.get("faq.amendment")}
                    arrivalDate={arrivalDate}
                    arrivalTime={arrivalTime}
                    departureDate={departureDate}
                    departureTime={departureTime}
                    cookies={this.props.cookies}
                    step={2}
                  />
                ) : (
                  <FaqTop3
                    faqContent={config.get("faq.search")}
                    arrivalDate={arrivalDate}
                    arrivalTime={arrivalTime}
                    departureDate={departureDate}
                    departureTime={departureTime}
                    cookies={this.props.cookies}
                    step={2}
                  />
                )}
                {this.state.refundGuaranteeModalOpen ? (
                  <SimpleErrorModal errorData={this.state.refundGuaranteeModalData} modalOpen={true} closeHandler={this.handleModalClose} />
                ) : (
                  ""
                )}
              </React.Fragment>
            )}
          />

          {/* simple time edit in ammendment flow */}
          <Route
            path={path.AMMEND_EDIT_TIME()}
            exact
            render={(props) => (
              <React.Fragment>
                <AmendProgressIndicator
                  step={1}
                  userAccountDetails={userAccountDetails}
                  setLoginState={this.setLoginState}
                  handleCurrentStep={this.handleCurrentStep}
                  handleLogOut={this.handleLogOut}
                  arrivalDate={arrivalDate}
                  arrivalTime={arrivalTime}
                  departureDate={departureDate}
                  departureTime={departureTime}
                  editTime={true}
                  {...this.props}
                  {...props}
                  {...this.state}
                />

                <section className="standalone-deck">
                  <h1 className="standalone-header">{amendmentManageTextKeys.editDateTimeHeader || "Ret dato og tid"}</h1>
                  <BookingEdit
                    wide={true}
                    flow={false}
                    modifiers={"x-parking-time-picker--flow"}
                    campaignCode={false}
                    slimVersion={true}
                    noneInverted={true}
                    noHeader={true}
                    formClasses={null}
                    isAmendment={true}
                    voucher={this.state.voucher}
                    searchData={{
                      ad: arrivalDate,
                      at: arrivalTime,
                      dd: departureDate,
                      dt: departureTime,
                      affiliateCode,
                    }}
                    textKeys={config.get("textKeys.bookingStarter") || {}}
                    {...this.props}
                    {...this.state}
                    {...props}
                    performParkingSearch={this.performParkingSearch}
                    performChangeBookingSearch={this.performChangeBookingTime}
                    showDefaultDates={false}
                    disclaimer={undefined}
                    buttonRemoveOnSearch={true}
                    bookingResult={this.props.bookingResult}
                    leadTimeInHours={this.props.content.leadTimeInHours || 1}
                  />
                </section>
                <ParkingAmendmentList
                  allProducts={allProducts}
                  autoSearch={this.state.queryStringDiffersFromAmendedBooking}
                  performParkingSearch={this.performParkingSearch}
                  performChangeBookingTime={this.performChangeBookingTime}
                  performChangeBookingSearch={this.performChangeBookingSearch}
                  arrivalDate={arrivalDate}
                  arrivalTime={arrivalTime}
                  departureDate={departureDate}
                  departureTime={departureTime}
                  voucher={voucher}
                  affiliateCode={affiliateCode}
                  getArrivalData={this.getArrivalData}
                  getDepartureData={this.getDepartureData}
                  handleReservation={this.handleReservation}
                  bookingResults={this.state.bookingResult}
                  removeBooking={this.removeBooking}
                  handleSorting={this.handleSorting}
                  changeFromBookingGuid={this.state.changeFromBookingGuid}
                  changeFromBooking={this.state.changeFromBooking}
                  manageBookingResult={this.state.manageBookingResult}
                  setParkingDetailModalState={this.setParkingDetailModalState}
                  focusOnContextBooking={true}
                  getExtraPrice={this.getExtraPrice}
                  isAmendment={true}
                  {...props}
                  {...this.props}
                  {...this.state}
                />
              </React.Fragment>
            )}
          />

          {/* extend parking ammendment flow */}
          <Route
            path={path.AMMEND_EXTEND_TIME()}
            exact
            render={(props) => (
              <React.Fragment>
                <AmendProgressIndicator
                  step={1}
                  userAccountDetails={userAccountDetails}
                  setLoginState={this.setLoginState}
                  handleCurrentStep={this.handleCurrentStep}
                  handleLogOut={this.handleLogOut}
                  arrivalDate={arrivalDate}
                  arrivalTime={arrivalTime}
                  departureDate={departureDate}
                  departureTime={departureTime}
                  editTime={true}
                  {...this.props}
                  {...props}
                  {...this.state}
                />
                {/* //focus */}
                <section className="standalone-deck">
                  <h1 className="standalone-header">{textKeys.amendment?.extend?.editDateTimeExitHeader || "Ret Udkørselstidspunkt"}</h1>
                  <BookingExtend
                    wide={true}
                    flow={false}
                    modifiers={"x-parking-time-picker--flow"}
                    campaignCode={false}
                    slimVersion={true}
                    noneInverted={true}
                    noHeader={true}
                    formClasses={null}
                    isAmendment={true}
                    voucher={this.state.voucher}
                    performChangeBookingExitTime={this.performChangeBookingExitTime}
                    handleBookingExtension={this.handleBookingExtension}
                    searchData={{
                      ad: arrivalDate,
                      at: arrivalTime,
                      dd: departureDate,
                      dt: departureTime,
                      affiliateCode,
                    }}
                    textKeys={config.get("textKeys.bookingStarter") || {}}
                    {...this.props}
                    {...this.state}
                    {...props}
                    performParkingSearch={this.performParkingSearch}
                    performChangeBookingSearch={this.performChangeBookingTime}
                    showDefaultDates={false}
                    disclaimer={undefined}
                    buttonRemoveOnSearch={true}
                    bookingResult={this.props.bookingResult}
                    leadTimeInHours={this.props.content.leadTimeInHours || 1}
                  />

                  {/* <ParkingExtendBookingList
            performChangeBookingTime={this.performChangeBookingExitTime}
            handleBookingExtension ={this.handleBookingExtension}
            {...this.state}
            {...this.props}
          /> */}
                </section>
              </React.Fragment>
            )}
          />

          <Route
            path={path.SEARCH_AMMEND_BOOKING()}
            exact
            render={(props) => (
              <React.Fragment>
                <AmendProgressIndicator
                  step={2}
                  editTime={true}
                  userAccountDetails={userAccountDetails}
                  setLoginState={this.setLoginState}
                  handleCurrentStep={this.handleCurrentStep}
                  handleLogOut={this.handleLogOut}
                  arrivalDate={arrivalDate}
                  arrivalTime={arrivalTime}
                  departureDate={departureDate}
                  departureTime={departureTime}
                  {...this.props}
                  {...props}
                  {...this.state}
                />
                <BookingStarter
                  wide={true}
                  flow={true}
                  modifiers={"parking-time-picker--blue parking-time-picker--flow"}
                  campaignCode={false}
                  slimVersion={true}
                  noHeader={true}
                  formClasses={null}
                  voucher={this.state.voucher}
                  searchData={{
                    ad: arrivalDate,
                    at: arrivalTime,
                    dd: departureDate,
                    dt: departureTime,
                    affiliateCode,
                  }}
                  textKeys={config.get("textKeys.bookingStarter") || {}}
                  {...this.props}
                  {...this.state}
                  {...props}
                  performParkingSearch={this.performParkingSearch}
                  performChangeBookingSearch={this.performChangeBookingSearch}
                  showDefaultDates={false}
                  disclaimer={undefined}
                  leadTimeInHours={this.props.content.leadTimeInHours || 1}
                />

                <StepHeader
                  title={stepHeaderTextKeys.step1 || "Vælg parkering"}
                  isParkingListView={false}
                  goBackPath={
                    !this.state.changeFromBookingGuid
                      ? { path: path.HOME() }
                      : {
                          path: path.AMMEND_SHOW_BOOKING(),
                          search: this.createQueryStrings({
                            email: this.state.ammendmentEmail,
                            reference: this.state.ammendmentReference,
                          }),
                        }
                  }
                  deck={"deck deck--white deck--padding-top deck--padding-bottom"}
                />

                <ParkingProductBrowser
                  showMapInitially={this.state.showMapInitially}
                  parkingList={
                    <ParkingList
                      isAmendment={true}
                      allProducts={allProducts}
                      performParkingSearch={this.performParkingSearch}
                      performChangeBookingSearch={this.performChangeBookingSearch}
                      arrivalDate={arrivalDate}
                      arrivalTime={arrivalTime}
                      departureDate={departureDate}
                      departureTime={departureTime}
                      voucher={voucher}
                      affiliateCode={affiliateCode}
                      getArrivalData={this.getArrivalData}
                      getDepartureData={this.getDepartureData}
                      handleReservation={this.handleReservation}
                      bookingResults={this.state.bookingResult}
                      removeBooking={this.removeBooking}
                      handleSorting={this.handleSorting}
                      changeFromBookingGuid={this.state.changeFromBookingGuid}
                      setParkingDetailModalState={this.setParkingDetailModalState}
                      {...props}
                      {...this.props}
                      {...this.state}
                    />
                  }
                  parkingMap={
                    allProducts.length > 0 ? (
                      <Map
                        allProducts={allProducts}
                        handleReservation={this.handleReservation}
                        setParkingDetailModalState={this.setParkingDetailModalState}
                        gaList={this.state.parkingDetailsModalGaList}
                        gaListIndex={this.state.parkingDetailsModalGaListIndex}
                        isAmendment={true}
                        {...this.props}
                        {...this.state}
                      />
                    ) : null
                  }
                  isAmendment={true}
                  arrivalDate={arrivalDate}
                  arrivalTime={arrivalTime}
                  departureDate={departureDate}
                  departureTime={departureTime}
                  {...this.props}
                  {...this.state}
                />
                {/* {this.state.changeFromBookingGuid ?
              <FaqTop3
                faqContent={config.get('faq.amendment')}
                arrivalDate={arrivalDate}
                arrivalTime={arrivalTime}
                departureDate={departureDate}
                departureTime={departureTime}
                cookies={this.props.cookies}
                step={2} /> :
              <FaqTop3
                faqContent={config.get('faq.search')}
                arrivalDate={arrivalDate}
                arrivalTime={arrivalTime}
                departureDate={departureDate}
                departureTime={departureTime}
                cookies={this.props.cookies}
                step={2} />} */}
              </React.Fragment>
            )}
          />

          <Route
            path={path.RECEIPT()}
            exact
            render={(props) => (
              <React.Fragment>
                <Spinner isActive={this.state.ajaxSpinnerActive} isTransparent={this.state.ajaxSpinnerTransparent} />
                <MenuBar
                  userAccountDetails={userAccountDetails}
                  setLoginState={this.setLoginState}
                  handleLogOut={this.handleLogOut}
                  clearBookingContext={this.clearBookingContext}
                  {...this.props}
                  {...props}
                />
                {/* <ProgressIndicator step={3} miniBasketToggle={this.miniBasketToggle} miniBasketActive={this.state.miniBasketActive} {...props} /> */}
                {/* <StepHeader {...props} title={'Betalingsoplysninger'} goBackPath={path.EXTRA_SERVICES()} /> */}
                <Receipt
                  bookingResult={this.state.bookingResult}
                  showGlobalSpinner={this.showGlobalSpinner}
                  receiptShouldTrack={this.state.receiptShouldTrack}
                  handleReasons={this.handleReasons}
                  {...props}
                  {...this.props}
                  getCart={this.getCart}
                  getExtraPrice={this.getExtraPrice}
                  setDataToState={this.setDataToState}
                  flightId={this.state.flightId}
                  useNewDesign={config.get("textKeys.productPodium")?.useNewProductPodiumDesign ?? false}
                />

                {this.state.bookingResult && followFlightTextKeys.showFollowFlight ? (
                  <UserProfile>
                    {(profile) => {
                      let p = null
                      if (profile) {
                        p = profile
                      }
                      return (
                        <ParkingFollowFlight
                          {...followFlightTextKeys}
                          arrivalDate={this.state.bookingResult.booking.arrivalDate}
                          arrivalTime={this.state.bookingResult.booking.arrivalTime}
                          departureDate={this.state.bookingResult.booking.departureDate}
                          departureTime={this.state.bookingResult.booking.departureTime}
                          email={this.state.bookingResult.booking.email}
                          phone={this.state.bookingResult.booking.mobilePhone}
                          locale={this.props.locale}
                          location={this.props.location}
                          modalTextKeys={followFlightSignupModalTextKeys}
                          profile={p}
                        />
                      )
                    }}
                  </UserProfile>
                ) : (
                  ""
                )}

                <ReceiptHowto bookingResult={this.state.bookingResult} content={this.props.content} />
                <ReceiptTextualGuide bookingResult={this.state.bookingResult} content={this.props.content} />
                <FaqTop3
                  faqContent={config.get("faq.receipt")}
                  arrivalDate={arrivalDate}
                  arrivalTime={arrivalTime}
                  departureDate={departureDate}
                  departureTime={departureTime}
                  cookies={this.props.cookies}
                  step={5}
                />
              </React.Fragment>
            )}
          />

          <Route
            path={path.AMMEND_CHECKOUT()}
            exact
            render={(props) => (
              <React.Fragment>
                <Spinner
                  isActive={this.state.ajaxSpinnerActive}
                  pleaseWaitText={textKeys.checkout.main.spinnerWaitingText ?? "Vent venligst.. det kan tage op til 1 minut"}
                  isTransparent={this.state.ajaxSpinnerTransparent}
                />
                <AmendProgressIndicator
                  editTime={true}
                  step={showExtraServicesStep ? 3 : 2}
                  userAccountDetails={userAccountDetails}
                  setLoginState={this.setLoginState}
                  handleCurrentStep={this.handleCurrentStep}
                  handleLogOut={this.handleLogOut}
                  arrivalDate={arrivalDate}
                  arrivalTime={arrivalTime}
                  departureDate={departureDate}
                  departureTime={departureTime}
                  {...this.props}
                  {...props}
                  {...this.state}
                />

                <StepHeader
                  isParkingListView={false}
                  {...this.props}
                  {...props}
                  title={isUpgrade ? amendmentUpgradeTextKeys.header || "Opgradering" : stepHeaderTextKeys.step3 || "Betalingsoplysninger"}
                  goBackPath={{ path: showExtraServicesStep ? path.EXTRA_SERVICES() : path.SEARCH() }}
                  deck={"deck deck--white deck--padding-top deck--padding-bottom"}
                />
                {this.state.bookingResult ? (
                  //turn this into AmendCheckout
                  <Checkout
                    {...this.state}
                    {...this.props}
                    {...props}
                    isAmendment={true}
                    addExtraToBooking={this.addExtraToBooking}
                    removeExtraFromBooking={this.removeExtraFromBooking}
                    executeUpsaleForBooking={this.executeUpsaleForBooking}
                    parkingTimeModalToogle={this.parkingTimeModalToogle}
                    updateCheckoutState={this.updateCheckoutState}
                    updateCheckoutErrors={this.updateCheckoutErrors}
                    updateCheckoutErrorsValues={this.updateCheckoutErrorsValues}
                    updateCheckoutErrorsRequiredFields={this.updateCheckoutErrorsRequiredFields}
                    prepareForPayment={this.prepareForPayment}
                    prepareForPaymentMobilePay={this.prepareForPaymentMobilePay}
                    paymentModalToggle={this.paymentModalToggle}
                    paymentModalHide={this.paymentModalHide}
                    setLoginState={this.setLoginState}
                    createQueryStrings={this.createQueryStrings}
                    setReceiptShouldTrack={this.setReceiptShouldTrack}
                    handleReasons={this.handleReasons}
                    handleSelectedPaymentType={this.handleSelectedPaymentType}
                    closePaymentModal={this.closePaymentModal}
                    genericModalOpen={this.genericModalOpen}
                    getExtraPrice={this.getExtraPrice}
                    setParkingDetailModalState={this.setParkingDetailModalState}
                    userAccountDetails={userAccountDetails}
                    validationMessageReplace={this.validationMessageReplace}
                    setDataToState={this.setDataToState}
                    gaList={this.state.parkingDetailsModalGaList}
                    gaListIndex={this.state.parkingDetailsModalGaListIndex}
                    checkoutErrors={!this.state.changeFromBooking ? this.state.checkoutErrors : {}}
                  />
                ) : null}
              </React.Fragment>
            )}
          />

          <Route
            path={path.EXTEND_CHECKOUT()}
            exact
            render={(props) => (
              <React.Fragment>
                <Spinner
                  isActive={this.state.ajaxSpinnerActive}
                  pleaseWaitText={textKeys.checkout.main.spinnerWaitingText ?? "Vent venligst.. det kan tage op til 1 minut"}
                  isTransparent={this.state.ajaxSpinnerTransparent}
                />
                <AmendProgressIndicator
                  editTime={true}
                  step={showExtraServicesStep ? 3 : 2}
                  userAccountDetails={userAccountDetails}
                  setLoginState={this.setLoginState}
                  handleCurrentStep={this.handleCurrentStep}
                  handleLogOut={this.handleLogOut}
                  arrivalDate={arrivalDate}
                  arrivalTime={arrivalTime}
                  departureDate={departureDate}
                  departureTime={departureTime}
                  {...this.props}
                  {...props}
                  {...this.state}
                />

                <StepHeader
                  isParkingListView={false}
                  {...this.props}
                  {...props}
                  title={isUpgrade ? amendmentUpgradeTextKeys.header || "Opgradering" : stepHeaderTextKeys.step3 || "Betalingsoplysninger"}
                  goBackPath={{ path: showExtraServicesStep ? path.EXTRA_SERVICES() : path.SEARCH() }}
                  deck={"deck deck--white deck--padding-top deck--padding-bottom"}
                />
                {this.state.bookingResult ? (
                  //turn this into AmendCheckout
                  <Checkout
                    {...this.state}
                    {...this.props}
                    {...props}
                    isAmendment={true}
                    addExtraToBooking={this.addExtraToBooking}
                    removeExtraFromBooking={this.removeExtraFromBooking}
                    executeUpsaleForBooking={this.executeUpsaleForBooking}
                    parkingTimeModalToogle={this.parkingTimeModalToogle}
                    updateCheckoutState={this.updateCheckoutState}
                    updateCheckoutErrors={this.updateCheckoutErrors}
                    updateCheckoutErrorsValues={this.updateCheckoutErrorsValues}
                    updateCheckoutErrorsRequiredFields={this.updateCheckoutErrorsRequiredFields}
                    prepareForPayment={this.prepareForPayment}
                    prepareForPaymentMobilePay={this.prepareForPaymentMobilePay}
                    paymentModalToggle={this.paymentModalToggle}
                    paymentModalHide={this.paymentModalHide}
                    setLoginState={this.setLoginState}
                    createQueryStrings={this.createQueryStrings}
                    setReceiptShouldTrack={this.setReceiptShouldTrack}
                    handleReasons={this.handleReasons}
                    handleSelectedPaymentType={this.handleSelectedPaymentType}
                    closePaymentModal={this.closePaymentModal}
                    genericModalOpen={this.genericModalOpen}
                    getExtraPrice={this.getExtraPrice}
                    setParkingDetailModalState={this.setParkingDetailModalState}
                    userAccountDetails={userAccountDetails}
                    validationMessageReplace={this.validationMessageReplace}
                    setDataToState={this.setDataToState}
                    gaList={this.state.parkingDetailsModalGaList}
                    gaListIndex={this.state.parkingDetailsModalGaListIndex}
                    checkoutErrors={!this.state.bookingExtension ? this.state.checkoutErrors : {}}
                  />
                ) : null}
              </React.Fragment>
            )}
          />

          <Route
            path={path.CHECKOUT()}
            exact
            render={(props) => (
              <React.Fragment>
                <Spinner
                  isActive={this.state.ajaxSpinnerActive}
                  pleaseWaitText={textKeys.checkout.main.spinnerWaitingText ?? "Vent venligst.. det kan tage op til 1 minut"}
                  isTransparent={this.state.ajaxSpinnerTransparent}
                />

                {!isUpgrade ? (
                  <>
                    <ProgressIndicator
                      step={showExtraServicesStep ? 3 : 2}
                      userAccountDetails={userAccountDetails}
                      setLoginState={this.setLoginState}
                      handleCurrentStep={this.handleCurrentStep}
                      handleLogOut={this.handleLogOut}
                      arrivalDate={arrivalDate}
                      arrivalTime={arrivalTime}
                      departureDate={departureDate}
                      departureTime={departureTime}
                      showExtraServicesStep={showExtraServicesStep}
                      {...this.props}
                      {...props}
                    />

                    <section className="checkout-basket-wrapper deck deck--blue">
                      <ParkingCheckoutBasket
                        {...this.state}
                        bookingResult={this.state.bookingResult}
                        priceFormatter={this.props.priceFormatter}
                        getExtraPrice={this.getExtraPrice}
                        parkingTimeModalToogle={this.parkingTimeModalToogle}
                        performParkingSearch={this.performParkingSearch}
                        removeExtraFromBooking={this.removeExtraFromBooking}
                        cookies={this.props.cookies}
                      />
                    </section>
                  </>
                ) : (
                  <AmendProgressIndicator
                    step={3}
                    userAccountDetails={userAccountDetails}
                    setLoginState={this.setLoginState}
                    handleCurrentStep={this.handleCurrentStep}
                    handleLogOut={this.handleLogOut}
                    arrivalDate={arrivalDate}
                    arrivalTime={arrivalTime}
                    departureDate={departureDate}
                    departureTime={departureTime}
                    editTime={true}
                    {...this.props}
                    {...props}
                    {...this.state}
                    ammendmentReference={this.state.changeFromBooking?.booking?.reference ?? ""}
                    ammendmentEmail={this.state.changeFromBooking?.booking?.email ?? ""}
                  />
                )}

                <StepHeader
                  isParkingListView={false}
                  {...this.props}
                  {...props}
                  title={isUpgrade ? amendmentUpgradeTextKeys.header || "Opgradering" : stepHeaderTextKeys.step3 || "Betalingsoplysninger"}
                  goBackPath={{ path: showExtraServicesStep ? path.EXTRA_SERVICES() : path.SEARCH() }}
                  deck={"deck deck--white deck--padding-top deck--padding-bottom"}
                />
                {this.state.bookingResult ? (
                  <Checkout
                    {...this.state}
                    {...this.props}
                    {...props}
                    isAmendment={false}
                    addExtraToBooking={this.addExtraToBooking}
                    removeExtraFromBooking={this.removeExtraFromBooking}
                    executeUpsaleForBooking={this.executeUpsaleForBooking}
                    parkingTimeModalToogle={this.parkingTimeModalToogle}
                    updateCheckoutState={this.updateCheckoutState}
                    updateCheckoutErrors={this.updateCheckoutErrors}
                    updateCheckoutErrorsValues={this.updateCheckoutErrorsValues}
                    updateCheckoutErrorsRequiredFields={this.updateCheckoutErrorsRequiredFields}
                    prepareForPayment={this.prepareForPayment}
                    prepareForPaymentMobilePay={this.prepareForPaymentMobilePay}
                    paymentModalToggle={this.paymentModalToggle}
                    paymentModalHide={this.paymentModalHide}
                    setLoginState={this.setLoginState}
                    createQueryStrings={this.createQueryStrings}
                    setReceiptShouldTrack={this.setReceiptShouldTrack}
                    handleReasons={this.handleReasons}
                    handleSelectedPaymentType={this.handleSelectedPaymentType}
                    closePaymentModal={this.closePaymentModal}
                    genericModalOpen={this.genericModalOpen}
                    getExtraPrice={this.getExtraPrice}
                    setParkingDetailModalState={this.setParkingDetailModalState}
                    userAccountDetails={userAccountDetails}
                    validationMessageReplace={this.validationMessageReplace}
                    setDataToState={this.setDataToState}
                    gaList={this.state.parkingDetailsModalGaList}
                    gaListIndex={this.state.parkingDetailsModalGaListIndex}
                    checkoutErrors={!this.state.changeFromBooking ? this.state.checkoutErrors : {}}
                    showExtraServicesStep={showExtraServicesStep}
                  />
                ) : (
                  <span></span>
                )}
                {this.state.changeFromBookingGuid ? (
                  <FaqTop3
                    faqContent={config.get("faq.amendment")}
                    arrivalDate={arrivalDate}
                    arrivalTime={arrivalTime}
                    departureDate={departureDate}
                    departureTime={departureTime}
                    cookies={this.props.cookies}
                    step={4}
                  />
                ) : (
                  <FaqTop3
                    faqContent={config.get("faq.checkout")}
                    arrivalDate={arrivalDate}
                    arrivalTime={arrivalTime}
                    departureDate={departureDate}
                    departureTime={departureTime}
                    cookies={this.props.cookies}
                    step={4}
                  />
                )}
              </React.Fragment>
            )}
          />
          {/* this is the date editor list box */}

          <Route
            path={path.HOME()}
            exact
            render={(props) => (
              <React.Fragment>
                <MenuBar
                  userAccountDetails={userAccountDetails}
                  setLoginState={this.setLoginState}
                  handleLogOut={this.handleLogOut}
                  clearBookingContext={this.clearBookingContext}
                  {...this.props}
                  {...props}
                />
                <BookingHero
                  imageUrl={(textKeys.mainApp && textKeys.mainApp.imageUrl) || "/static/photos/Kran_1600x600.png"}
                  videoUrl={(textKeys.mainApp && textKeys.mainApp.videoUrl) || "/static/video/Kran_1600x600.mp4"}
                  headline={(textKeys.mainApp && textKeys.mainApp.subTitle) || 'Parkering fra kun <span class="t--highlight">395,-</span> pr. uge'}
                  label={(textKeys.mainApp && textKeys.mainApp.title) || "Parkering & Transport"}
                  button={(textKeys.mainApp && textKeys.mainApp.buttonText) || "Book nu"}
                  tooltipHeadline={textKeys.mainApp && textKeys.mainApp.tooltipHeadline}
                  tooltipText={textKeys.mainApp && textKeys.mainApp.tooltipText}
                  tooltipPreview={textKeys.mainApp && textKeys.mainApp.tooltipPreviewText}
                  tooltipReadMore={(textKeys.mainApp && textKeys.mainApp.tooltipReadMoreEllipsis) || "... læs mere"}
                  {...refundGuaranteeTextKeys}
                  searchData={{
                    ad: arrivalDate,
                    at: arrivalTime,
                    dd: departureDate,
                    dt: departureTime,
                    affiliateCode,
                  }}
                  textKeys={config.get("textKeys.bookingStarter") || {}}
                  {...this.props}
                  {...props}
                  performParkingSearch={this.performParkingSearch}
                  showDefaultDates={false}
                  leadTimeInHours={this.props.content.leadTimeInHours || 1}
                />
                <SubnavigationFat subnavigationItems={config.get("subnavigationFat.items")} />
              </React.Fragment>
            )}
          />

          {/* self service booking management */}

          <Route
            path={path.AMMEND_SEARCH()}
            exact
            render={() => (
              <React.Fragment>
                <div className="header-container">
                  <Header
                    userAccountDetails={userAccountDetails}
                    setLoginState={this.setLoginState}
                    handleLogOut={this.handleLogOut}
                    clearBookingContext={this.clearBookingContext}
                    languages={this.props.languages}
                    locale={this.props.locale}
                    onlyTopLevel={this.props.headerData.disableMegaMenu}
                    loginState={this.props.loginState}
                    searchConfig={this.props.searchConfig}
                    useParkingLanguageSelection={true}
                    {...this.props.headerData}
                  />
                </div>
                <AmendSearch
                  findBooking={this.findBooking}
                  amendForgotReferenceModalToogle={this.amendForgotReferenceModalToogle}
                  updateAmmendmentEmailValue={this.updateAmmendmentEmailValue}
                  updateAmmendmentReferenceValue={this.updateAmmendmentReferenceValue}
                  {...this.state}
                  {...this.props}
                />
              </React.Fragment>
            )}
          />
          <Route
            path={path.AMMEND_SHOW_BOOKING()}
            exact
            render={(props) => (
              <React.Fragment>
                <div className="header-container">
                  <Header
                    userAccountDetails={userAccountDetails}
                    setLoginState={this.setLoginState}
                    handleLogOut={this.handleLogOut}
                    clearBookingContext={this.clearBookingContext}
                    languages={this.props.languages}
                    locale={this.props.locale}
                    onlyTopLevel={this.props.headerData.disableMegaMenu}
                    loginState={this.props.loginState}
                    searchConfig={this.props.searchConfig}
                    useParkingLanguageSelection={true}
                    {...this.props.headerData}
                  />
                </div>
                <AmendHeaderSection
                  description={amendmentManageTextKeys.description || "Se, redigér eller annullér booking nr."}
                  title={amendmentManageTextKeys.title || "Administrér din booking"}
                  manageBookingResult={this.state.manageBookingResult}
                />

                <AmendManage
                  manageBookingResult={this.state.manageBookingResult}
                  bookingUpsale={this.state.bookingUpsale}
                  performChangeBookingSearch={this.performChangeBookingSearch}
                  performChangeBookingTime={this.performChangeBookingTime}
                  performChangeBookingExitTime={this.performChangeBookingExitTime}
                  resendBookingReceipt={this.resendBookingReceipt}
                  setParkingDetailModalState={this.setParkingDetailModalState}
                  executeUpsaleForBooking={this.executeUpsaleForBooking}
                  cancelBooking={this.cancelBooking}
                  removeHeader={this.removeHeader}
                  {...this.props}
                  genericModalOpen={this.genericModalOpen}
                  {...props}
                  getExtraPrice={this.getExtraPrice}
                  setDataToState={this.setDataToState}
                  createQueryStrings={this.createQueryStrings}
                />

                <FaqTop3
                  faqContent={config.get("faq.amendment")}
                  arrivalDate={arrivalDate}
                  arrivalTime={arrivalTime}
                  departureDate={departureDate}
                  departureTime={departureTime}
                  cookies={this.props.cookies}
                  step={6}
                />
              </React.Fragment>
            )}
          />
          <Route
            path={path.AMMEND_EDIT_INFO()}
            exact
            render={(props) => (
              <React.Fragment>
                <div className="header-container">
                  <Header
                    userAccountDetails={userAccountDetails}
                    setLoginState={this.setLoginState}
                    handleLogOut={this.handleLogOut}
                    clearBookingContext={this.clearBookingContext}
                    languages={this.props.languages}
                    locale={this.props.locale}
                    onlyTopLevel={this.props.headerData.disableMegaMenu}
                    loginState={this.props.loginState}
                    searchConfig={this.props.searchConfig}
                    useParkingLanguageSelection={true}
                    {...this.props.headerData}
                  />
                </div>
                <AmendHeaderSection
                  title={amendmentEditInfoTextKeys.title || "Redigér information"}
                  description={amendmentEditInfoTextKeys.description || "Redigér information for booking nr."}
                  manageBookingResult={this.state.manageBookingResult}
                />
                <AmendInformation
                  manageBookingResult={this.state.manageBookingResult}
                  modifyBookingInformation={this.modifyBookingInformation}
                  validationMessageReplace={this.validationMessageReplace}
                  {...this.props}
                  {...props}
                />
              </React.Fragment>
            )}
          />
          <Route path={path.NOT_FOUND()} render={() => <NotFound genericModalOpen={this.genericModalOpen} />} />
          <Redirect path="/" exact to={path.HOME()} />
          <Redirect to={path.NOT_FOUND()} />
        </Switch>
        {showExtraServicesStep ? (
          <Route
            path={path.EXTRA_SERVICES()}
            exact
            render={(props) => (
              <React.Fragment>
                <ParkingExtraServicesSelectorModal
                  isActive={this.state.extraServiceModalSelectorActive}
                  extraServiceModalSelectorToogle={this.extraServiceModalSelectorToogle}
                  extraProduct={this.state.extraServiceModalProduct}
                  extraServicesAcceptConditionsModalActivate={this.extraServicesAcceptConditionsModalActivate}
                  addExtraToBooking={this.addExtraToBooking}
                  removeExtraFromBooking={this.removeExtraFromBooking}
                  {...this.state}
                  {...this.props}
                  {...props}
                />

                <ParkingExtraServicesInfoModal
                  isActive={this.state.extraServicesInfoModalActive}
                  extraServiceModalInfoToogle={this.extraServiceModalInfoToogle}
                  extraProduct={this.state.extraServiceModalProduct}
                />

                <ParkingExtraServicesDetailsModal
                  isActive={this.state.extraServicesDetailsModalActive}
                  extraServicesDetailsModalToggle={this.extraServicesDetailsModalToggle}
                  extraProduct={this.state.extraServiceModalProduct}
                  extraProductOffer={this.state.extraServiceModalProductOffer}
                  contentVariant={this.state.extraServiceModalContentVariant}
                />

                <ParkingExtraServiceAcceptConditionsModal
                  isActive={this.state.extraServicesAcceptConditionsModalActive}
                  // extraServicesAcceptConditionsModalAccept={this.extraServicesAcceptConditionsModalAccept}
                  extraServicesAcceptConditionsModalCancel={this.extraServicesAcceptConditionsModalCancel}
                  extraServicesAcceptConditionsModalClose={this.extraServicesAcceptConditionsModalClose}
                  addExtraToBooking={this.addExtraToBooking}
                  removeExtraFromBooking={this.removeExtraFromBooking}
                  extraProduct={this.state.extraServiceModalProduct}
                  {...this.state}
                  {...this.props}
                  {...props}
                />
              </React.Fragment>
            )}
          />
        ) : null}

        {/* modals */}

        {this.state.parkingTimeModalActive ? (
          <ParkingTimeModal
            arrivalDate={this.state.arrivalDate}
            arrivalTime={this.state.arrivalTime}
            departureDate={this.state.departureDate}
            departureTime={this.state.departureTime}
            voucher={this.state.voucher}
            affiliateCode={this.state.affiliateCode}
            parkingTimeModalToogle={this.parkingTimeModalToogle}
            performParkingSearch={this.performParkingSearch}
            performChangeBookingSearch={this.performChangeBookingSearch}
            {...this.props}
            leadTimeInHours={this.props.content.leadTimeInHours || 1}
            useNewDesign={config.get("textKeys.productPodium")?.useNewProductPodiumDesign ?? false}
          />
        ) : null}

        {this.state.forgotReferenceModalActive ? (
          <AmendForgotReferenceModal
            amendForgotReferenceModalToogle={this.amendForgotReferenceModalToogle}
            resendNextAvailableBookingConfirmation={this.resendNextAvailableBookingConfirmation}
            ammendmentEmail={this.state.ammendmentEmail}
            updateAmmendmentEmailValue={this.updateAmmendmentEmailValue}
            {...this.props}
          />
        ) : null}
        {/* add this to revert back to payment modal instead of redirect payment */}
        {/* {
          this.state.paymentModalActive && this.state.paymentData ?
            <CheckoutPaymentModal
              bookingResult={this.state.bookingResult}
              paymentData={this.state.paymentData}
              paymentModalToggle={this.paymentModalToggle}
              {...this.props}
            />
            : null
        } */}
        {this.state.emailUpgradeInProcess ? (
          <SpinnerModal
            genericModalBody={
              config.get("textKeys.dialog.upgrade") ||
              "<h3>Opgradering af booking</h3><p>Vent et øjeblik mens vi behandler din opgradering</p><p></p>"
            }
            isSpinnerActive={true}
          />
        ) : null}
        {this.state.genericModalActive ? <GenericModal genericModalClose={this.genericModalClose} {...this.state} {...this.props} /> : null}
        {this.state.isParkingDetailsModalActive ? (
          <ParkingDetailsModal
            gaList={this.state.parkingDetailsModalGaList}
            gaListIndex={this.state.parkingDetailsModalGaListIndex}
            isActive={this.state.isParkingDetailsModalActive}
            allProducts={this.state.allProducts}
            item={this.state.parkingDetailsModalItem}
            buttonTextOverride={this.state.parkingDetailsModalButtonTextOverride}
            buttonClickOverride={this.state.parkingDetailsModalButtonClickOverride}
            trackingEventLabel={this.state.parkingDetailsModalTrackingEventLabel}
            handleReservation={this.handleReservation}
            handleParkingDetailsClose={this.handleParkingDetailsClose}
            handleParkingDetailsCleanup={this.handleParkingDetailsCleanup}
            handleSpecialProductClickFromDetails={this.handleSpecialProductClickFromDetails}
            handleDetailsCleanup={this.handleBuySpecialProductCleanup}
            location={this.props.location}
            durationDays={this.state.durationDays}
            setParkingDetailModalState={this.setParkingDetailModalState}
            handleCloseMapModal={this.handleCloseMapModal}
            handleOpenMapModal={this.handleOpenMapModal}
            isParkingProductMapModalActive={this.state.isParkingProductMapModalActive}
            isParkingHighlightModalActive={this.state.isParkingHighlightModalActive}
            userAccountDetails={userAccountDetails}
            setLoginState={this.setLoginState}
            useNewDesign={config.get("textKeys.productPodium")?.useNewProductPodiumDesign ?? false}
            {...this.props}
            {...this.state}
          />
        ) : null}
        {this.state.isParkingSpecialProductActive ? (
          <ParkingAcceptConditionsModal
            gaList={this.props.gaList}
            gaListIndex={this.props.gaListIndex}
            isActive={this.state.isParkingSpecialProductActive}
            item={this.state.parkingDetailsModalItem}
            handleReservation={this.handleReservation}
            handleSpecialProductDetailsClose={this.handleSpecialProductDetailsClose}
            handleSpecialProductDetailsCleanup={this.handleSpecialProductDetailsCleanup}
            location={this.props.location}
            durationDays={this.state.durationDays}
            setParkingDetailModalState={this.setParkingDetailModalState}
            buttonClickOverride={this.state.parkingDetailsModalButtonClickOverride}
            {...this.props}
          />
        ) : null}
        {this.state.isParkingMemberProductActive ? (
          <ParkingBuyMemberProductModal
            gaList={this.props.gaList}
            gaListIndex={this.props.gaListIndex}
            isActive={this.state.isParkingMemberProductActive}
            changeFromBooking={this.state.changeFromBooking}
            item={this.state.parkingDetailsModalItem}
            handleReservation={this.handleReservation}
            handleBuyMemberProductModalClose={this.handleBuyMemberProductModalClose}
            handleDetailsCleanup={this.handleBuyMemberProductCleanup}
            isAmendment={true}
            location={this.props.location}
            durationDays={this.state.durationDays}
            setParkingDetailModalState={this.setParkingDetailModalState}
            setLoginState={this.setLoginState}
            {...this.props}
            userAccountDetails={this.state.userAccountDetails}
          />
        ) : null}
        {this.state.isParkingProductMapModalActive ? (
          <ParkingShowMapModal
            item={this.state.parkingDetailsModalItem}
            handleCloseMapModal={this.handleCloseMapModal}
            handleOpenMapModal={this.handleOpenMapModal}
            {...this.props}
          />
        ) : null}
      </React.Fragment>
    )
    // }
  }

  handleCloseMapModal = () => {
    this.setState({ isParkingProductMapModalActive: false })
  }

  handleOpenMapModal = () => {
    this.setState({
      isParkingProductMapModalActive: true,
      isParkingSpecialProductActive: false,
      isParkingDetailsModalActive: false,
    })
  }

  handleSpecialProductClickFromDetails = () => {
    this.setState({ isParkingDetailsModalActive: false, isParkingSpecialProductActive: true })
  }

  handleParkingDetailsClose = (callback) => {
    this.setState(
      {
        isParkingDetailsModalActive: false,
        isParkingHighlightModalActive: false,
      },
      callback,
    )
  }

  handleParkingDetailsCleanup = () => {
    this.setState({
      parkingDetailsModalGaList: undefined,
      parkingDetailsModalGaListIndex: undefined,
      parkingDetailsModalItem: undefined,
      parkingDetailsModalButtonTextOverride: undefined,
      parkingDetailsModalButtonClickOverride: undefined,
    })
  }

  handleSpecialProductDetailsClose = (callback) => {
    this.setState(
      {
        isParkingSpecialProductActive: false,
      },
      callback,
    )
  }

  handleSpecialProductDetailsCleanup = (callback) => {
    this.setState(
      {
        parkingDetailsModalGaList: undefined,
        parkingDetailsModalGaListIndex: undefined,
        parkingDetailsModalItem: undefined,
      },
      callback,
    )
  }

  handleBuyMemberProductModalClose = (callback) => {
    this.setState(
      {
        isParkingMemberProductActive: false,
      },
      callback,
    )
  }

  handleBuyMemberProductCleanup = (callback) => {
    this.setState(
      {
        parkingDetailsModalGaList: undefined,
        parkingDetailsModalGaListIndex: undefined,
        parkingDetailsModalItem: undefined,
      },
      callback,
    )
  }

  setParkingDetailModalState = (state) => {
    this.setState(state)
  }
}

export default withCookies(withRouter(BookingJourney))
